// ===== GERMAN PERFUME CATALOG - COMPLETE WITH ALL PRODUCTS =====
// Save this as: assets/perfume-catalog-minimal.js
// INCLUDES ALL PRODUCTS FROM YOUR STORE - COMPREHENSIVE LIST
// UPDATED: Added missing product numbers and fixed gender mappings

window.PerfumeCatalog = {
  // ===== VALENTINO =====
  valentino: [
    {
      id: "valentino_born_in_roma",
      name: "Born in Roma Valentino",
      brand: "Valentino",
      image: "https://magicperfume.co/cdn/shop/files/Valentino_Donna_Born_In_Roma.png?v=1770224306",
      top_notes: ["Schwarze Johannisbeere", "Bergamotte", "Jasmin"],
      heart_notes: ["Rose", "Jasmin", "Zeder"],
      base_notes: ["Vanille", "Moschus", "Zeder"],
      description: "Ein moderner und kantiger Duft, der den Geist der römischen Jugendkultur einfängt.",
      year: "2019",
      gender: "Female",
      productNumbers: ["469"],
      shopifyProduct: {
        title: "Riecht wie... Born in Roma - No. 469 (w)",
        url: "https://magicperfume.co/products/magic-perfume-no-469w",
        price: "€11.99",
        image: "https://magicperfume.co/cdn/shop/files/Valentino_Donna_Born_In_Roma.png?v=1770224306"
      }
    },
    {
      id: "valentino_uomo_born_in_roma",
      name: "Uomo Born in Roma Valentino",
      brand: "Valentino",
      image: "https://magicperfume.co/cdn/shop/files/Valentino_Uomo_Born_in_Roma.png?v=1770289172",
      top_notes: ["Mandarine", "Salz", "Minze"],
      heart_notes: ["Lavendel", "Salbei", "Zeder"],
      base_notes: ["Vanille", "Tonkabohne", "Moschus"],
      description: "Ein frischer und aromatischer Duft für den modernen Mann.",
      year: "2019",
      gender: "Male",
      productNumbers: ["360"],
      shopifyProduct: {
        title: "Riecht wie... Uomo Born in Roma - No. 360 (m)",
        url: "https://magicperfume.co/products/magic-perfume-no-360m",
        price: "€11.99",
        image: "https://magicperfume.co/cdn/shop/files/Valentino_Uomo_Born_in_Roma.png?v=1770289172"
      }
    }
  ],

  // ===== PRADA =====
  prada: [
    {
      id: "prada_paradoxe",
      name: "Paradoxe Prada",
      brand: "Prada",
      image: "https://magicperfume.co/cdn/shop/files/Prada_Paradoxe.jpg?v=1771894273",
      top_notes: ["Birne", "Bergamotte", "Mandarine"],
      heart_notes: ["Orangenblüte", "Jasmin", "Rose"],
      base_notes: ["Vanille", "Amber", "Zeder"],
      description: "Ein moderner und paradoxer Duft, der mit Kontrasten spielt.",
      year: "2022",
      gender: "Female",
      productNumbers: ["437"],
      shopifyProduct: {
        title: "Riecht wie... Paradoxe - No. 437 (w)",
        url: "https://magicperfume.co/products/magic-perfume-no-437w",
        price: "€11.99",
        image: "https://magicperfume.co/cdn/shop/files/Prada_Paradoxe.jpg?v=1771894273"
      }
    },
    {
      id: "prada_candy",
      name: "Candy Prada",
      brand: "Prada",
      image: "https://magicperfume.co/cdn/shop/files/Prada_Candy.avif?v=1770581340",
      top_notes: ["Karamell", "Moschus", "Vanille"],
      heart_notes: ["Benzoin", "Moschus"],
      base_notes: ["Vanille", "Moschus", "Karamell"],
      description: "Ein verspielter und genüsslicher Gourmand-Duft, der den Geist von Spaß und Weiblichkeit einfängt.",
      year: "2011",
      gender: "Female",
      productNumbers: ["182"],
      shopifyProduct: {
        title: "Riecht wie... Candy - No. 182 (w)",
        url: "https://magicperfume.co/products/magic-perfume-no-182w",
        price: "€11.99",
        image: "https://magicperfume.co/cdn/shop/files/Prada_Candy.avif?v=1770581340"
      }
    }
  ],

  // ===== LANCOME =====
  lancome: [
    {
      id: "lancome_la_vie_est_belle",
      name: "La Vie Est Belle Lancôme",
      brand: "Lancôme",
      image: "https://magicperfume.co/cdn/shop/files/Lancome_La_Vie_Est_Belle.png?v=1770220684",
      top_notes: ["Schwarze Johannisbeere", "Birne", "Orangenblüte"],
      heart_notes: ["Iris", "Jasmin", "Orangenblüte"],
      base_notes: ["Praliné", "Vanille", "Patschuli", "Tonkabohne"],
      description: "Ein strahlender und freudiger Duft, der die Schönheit des Lebens feiert.",
      year: "2012",
      gender: "Female",
      productNumbers: ["101"],
      shopifyProduct: {
        title: "Riecht wie... La Vie Est Belle - No. 101 (w)",
        url: "https://magicperfume.co/products/magic-perfume-no-101w",
        price: "€11.99",
        image: "https://magicperfume.co/cdn/shop/files/Lancome_La_Vie_Est_Belle.png?v=1770220684"
      }
    },
    {
      id: "lancome_la_vie_est_belle_intensement",
      name: "La Vie Est Belle Intensément Lancôme",
      brand: "Lancôme",
      image: "https://magicperfume.co/cdn/shop/files/Lancome_La_Vie_Est_Belle_Intensement.png?v=1772101772",
      top_notes: ["Mandarine", "Schwarze Johannisbeere", "Bergamotte"],
      heart_notes: ["Tuberose", "Jasmin", "Orangenblüte"],
      base_notes: ["Praliné", "Vanille", "Patschuli", "Tonkabohne"],
      description: "Eine intensivere und üppigere Interpretation von La Vie Est Belle.",
      year: "2017",
      gender: "Female",
      productNumbers: ["109"],
      shopifyProduct: {
        title: "Riecht wie... La Vie Est Belle Intensement - No. 109 (w)",
        url: "https://magicperfume.co/products/magic-perfume-no-109w",
        price: "€11.99",
        image: "https://magicperfume.co/cdn/shop/files/Lancome_La_Vie_Est_Belle_Intensement.png?v=1772101772"
      }
    },
    {
      id: "lancome_tresor",
      name: "Trésor Lancôme",
      brand: "Lancôme",
      image: "https://magicperfume.co/cdn/shop/files/Lancome_Tresor.png?v=1770285746",
      top_notes: ["Pfirsich", "Aprikose", "Rose"],
      heart_notes: ["Maiglöckchen", "Jasmin", "Iris"],
      base_notes: ["Vanille", "Sandelholz", "Moschus"],
      description: "Ein romantischer und zeitloser Duft, der die Essenz der Liebe einfängt.",
      year: "1990",
      gender: "Female",
      productNumbers: ["141"],
      shopifyProduct: {
        title: "Riecht wie... Trésor - No. 141 (w)",
        url: "https://magicperfume.co/products/magic-perfume-no-141w",
        price: "€11.99",
        image: "https://magicperfume.co/cdn/shop/files/Lancome_Tresor.png?v=1770285746"
      }
    },
    {
      id: "lancome_idole",
      name: "Idôle Lancôme",
      brand: "Lancôme",
      image: "https://magicperfume.co/cdn/shop/files/Idole.webp?v=1772097147",
      top_notes: ["Birne", "Bergamotte", "Zitrone"],
      heart_notes: ["Rose", "Jasmin", "Magnolie"],
      base_notes: ["Vanille", "Moschus", "Zeder"],
      description: "Ein moderner und eleganter Duft für die neue Generation von Frauen.",
      year: "2019",
      gender: "Female",
      productNumbers: ["055"],
      shopifyProduct: {
        title: "Riecht wie... Idole - No. 055 (w)",
        url: "https://magicperfume.co/products/magic-perfume-no-055w",
        price: "€11.99",
        image: "https://magicperfume.co/cdn/shop/files/Idole.webp?v=1772097147"
      }
    }
  ],

  // ===== YVES SAINT LAURENT =====
  ysl: [
    {
      id: "ysl_libre",
      name: "Libre Yves Saint Laurent",
      brand: "Yves Saint Laurent",
      image: "https://magicperfume.co/cdn/shop/files/YSL_Libre.jpg",
      top_notes: ["Lavendel", "Bergamotte", "Mandarine"],
      heart_notes: ["Orangenblüte", "Jasmin", "Rose"],
      base_notes: ["Vanille", "Amber", "Moschus"],
      description: "Ein freier und kühner Duft für die selbstbewusste Frau.",
      year: "2019",
      gender: "Female",
      productNumbers: ["034"],
      shopifyProduct: {
        title: "Riecht wie... LIBRE - No. 034 (w)",
        url: "https://magicperfume.co/products/magic-perfume-no-034w",
        price: "€11.99",
        image: "https://magicperfume.co/cdn/shop/files/YSL_Libre.jpg"
      }
    },
    {
      id: "ysl_black_opium",
      name: "Black Opium Yves Saint Laurent",
      brand: "Yves Saint Laurent",
      image: "https://magicperfume.co/cdn/shop/files/Yves_Saint_Laurent_Black_Opium.png?v=1770217557",
      top_notes: ["Kaffee", "Rosa Pfeffer", "Orangenblüte"],
      heart_notes: ["Jasmin", "Bittermandel", "Lakritze"],
      base_notes: ["Vanille", "Zeder", "Patschuli"],
      description: "Ein kühner und kantiger Duft, der den Geist der Rockkultur einfängt.",
      year: "2014",
      gender: "Female",
      productNumbers: ["132"],
      shopifyProduct: {
        title: "Riecht wie... Black Opium - No. 132 (w)",
        url: "https://magicperfume.co/products/magic-perfume-no-132w",
        price: "€11.99",
        image: "https://magicperfume.co/cdn/shop/files/Yves_Saint_Laurent_Black_Opium.png?v=1770217557"
      }
    },
    {
      id: "ysl_opium",
      name: "Opium Yves Saint Laurent",
      brand: "Yves Saint Laurent",
      image: "https://magicperfume.co/cdn/shop/files/Yves_Saint_Laurent_Opium.jpg?v=1770580952",
      top_notes: ["Mandarine", "Pflaume", "Nelke", "Koriander"],
      heart_notes: ["Nelke", "Rose", "Jasmin", "Maiglöckchen"],
      base_notes: ["Opium", "Myrrhe", "Amber", "Sandelholz"],
      description: "Ein legendärer orientalischer Duft, der sowohl würzig als auch sinnlich ist.",
      year: "1977",
      gender: "Female",
      productNumbers: ["083"],
      shopifyProduct: {
        title: "Riecht wie... Laurent Opium - No. 083 (w)",
        url: "https://magicperfume.co/products/magic-perfume-no-083w",
        price: "€11.99",
        image: "https://magicperfume.co/cdn/shop/files/Yves_Saint_Laurent_Opium.jpg?v=1770580952"
      }
    },
    {
      id: "ysl_y",
      name: "Y Yves Saint Laurent",
      brand: "Yves Saint Laurent",
      image: "https://magicperfume.co/cdn/shop/files/Yves_Saint_Laurent_Y.png?v=1771482466",
      top_notes: ["Bergamotte", "Ingwer", "Aldehyde"],
      heart_notes: ["Salbei", "Wacholder", "Geranie"],
      base_notes: ["Amber", "Zeder", "Moschus"],
      description: "Ein frischer und holziger Duft, der eine neue Generation repräsentiert.",
      year: "2017",
      gender: "Male",
      productNumbers: ["283"],
      shopifyProduct: {
        title: "Riecht wie... Y - No. 283 (m)",
        url: "https://magicperfume.co/products/magic-perfume-no-283m",
        price: "€11.99",
        image: "https://magicperfume.co/cdn/shop/files/Yves_Saint_Laurent_Y.png?v=1771482466"
      }
    }
  ],

  // ===== CAROLINA HERRERA =====
  carolinaHerrera: [
    {
      id: "carolina_good_girl",
      name: "Good Girl Carolina Herrera",
      brand: "Carolina Herrera",
      image: "https://magicperfume.co/cdn/shop/files/Carolina_Herrera_Good_Girl_Velvet_Fatale.png?v=1770218974",
      top_notes: ["Pflaume", "Safran", "Bergamotte"],
      heart_notes: ["Tuberose", "Jasmin", "Orangenblüte"],
      base_notes: ["Leder", "Vanille", "Patschuli", "Tonkabohne"],
      description: "Eine dunklere, geheimnisvollere Interpretation von Good Girl.",
      year: "2022",
      gender: "Female",
      productNumbers: ["461"],
      shopifyProduct: {
        title: "Riecht wie... Good Girl - No. 461 (w)",
        url: "https://magicperfume.co/products/magic-perfume-no-461w",
        price: "€11.99",
        image: "https://magicperfume.co/cdn/shop/files/Carolina_Herrera_Good_Girl_Velvet_Fatale.png?v=1770218974"
      }
    },
    {
      id: "carolina_very_good_girl",
      name: "Very Good Girl Carolina Herrera",
      brand: "Carolina Herrera",
      image: "https://magicperfume.co/cdn/shop/files/Carolina_Herrera_Very_Good_Girl.png?v=1770292680",
      top_notes: ["Rote Johannisbeere", "Litschi", "Bergamotte"],
      heart_notes: ["Rose", "Jasmin", "Orangenblüte"],
      base_notes: ["Vanille", "Tonkabohne", "Zeder", "Patschuli"],
      description: "Eine kühne und glamouröse Interpretation von Good Girl.",
      year: "2021",
      gender: "Female",
      productNumbers: ["404"],
      shopifyProduct: {
        title: "Riecht wie... Very Good Girl - No. 404 (w)",
        url: "https://magicperfume.co/products/magic-perfume-no-404w",
        price: "€11.99",
        image: "https://magicperfume.co/cdn/shop/files/Carolina_Herrera_Very_Good_Girl.png?v=1770292680"
      }
    }
  ],

  // ===== PACO RABANNE =====
  pacoRabanne: [
    {
      id: "paco_one_million",
      name: "1 Million Paco Rabanne",
      brand: "Paco Rabanne",
      image: "https://magicperfume.co/cdn/shop/files/Paco_Rabanne_One_Million.png?v=1770217929",
      top_notes: ["Grapefruit", "Minze", "Mandarine"],
      heart_notes: ["Zimt", "Rose", "Gewürze"],
      base_notes: ["Leder", "Amber", "Patschuli"],
      description: "Ein kühner und verführerischer Duft für den Mann, der seinen Wert kennt.",
      year: "2008",
      gender: "Male",
      productNumbers: ["275"],
      shopifyProduct: {
        title: "Riecht wie… One Million - No. 275 (m)",
        url: "https://magicperfume.co/products/magic-perfume-no-275m",
        price: "€11.99",
        image: "https://magicperfume.co/cdn/shop/files/Paco_Rabanne_One_Million.png?v=1770217929"
      }
    },
    {
      id: "paco_one_million_elixir",
      name: "1 Million Elixir Paco Rabanne",
      brand: "Paco Rabanne",
      image: "https://magicperfume.co/cdn/shop/files/Paco_Rabanne_One_Million_Elixir.png?v=1770579856",
      top_notes: ["Grapefruit", "Mandarine", "Minze"],
      heart_notes: ["Zimt", "Rose", "Safran"],
      base_notes: ["Leder", "Amber", "Vanille", "Patschuli"],
      description: "Eine intensivere und konzentriertere Version des ikonischen 1 Million.",
      year: "2020",
      gender: "Male",
      productNumbers: ["334"],
      shopifyProduct: {
        title: "Riecht wie... One Million Elixir - No. 334 (m)",
        url: "https://magicperfume.co/products/magic-perfume-no-334m",
        price: "€11.99",
        image: "https://magicperfume.co/cdn/shop/files/Paco_Rabanne_One_Million_Elixir.png?v=1770579856"
      }
    },
    {
      id: "paco_one_million_lucky",
      name: "One Million Lucky Paco Rabanne",
      brand: "Paco Rabanne",
      image: "https://magicperfume.co/cdn/shop/files/One_Million_Lucky.webp?v=1772135132",
      top_notes: ["Pflaume", "Grapefruit", "Mandarine"],
      heart_notes: ["Honig", "Zeder", "Eichenmoos"],
      base_notes: ["Leder", "Amber", "Patschuli"],
      description: "Eine frische und holzige Interpretation des ikonischen One Million.",
      year: "2018",
      gender: "Male",
      productNumbers: ["280"],
      shopifyProduct: {
        title: "Riecht wie... One Million Lucky - No. 280 (m)",
        url: "https://magicperfume.co/products/magic-perfume-no-280m",
        price: "€20.99",
        image: "https://magicperfume.co/cdn/shop/files/One_Million_Lucky.webp?v=1772135132"
      }
    },
    {
      id: "paco_lady_million",
      name: "Lady Million Paco Rabanne",
      brand: "Paco Rabanne",
      image: "https://magicperfume.co/cdn/shop/files/Paco_Rabanne_Lady_Million.png?v=1770218839",
      top_notes: ["Himbeere", "Neroli", "Zitrone"],
      heart_notes: ["Orangenblüte", "Jasmin", "Honig"],
      base_notes: ["Patschuli", "Amber", "Zeder"],
      description: "Ein schillernder und glamouröser Duft für die moderne Frau.",
      year: "2010",
      gender: "Female",
      productNumbers: ["023"],
      shopifyProduct: {
        title: "Riecht wie... LADY MILION - No. 023 (w)",
        url: "https://magicperfume.co/products/magic-perfume-no-023w",
        price: "€11.99",
        image: "https://magicperfume.co/cdn/shop/files/Paco_Rabanne_Lady_Million.png?v=1770218839"
      }
    },
    {
      id: "paco_fame",
      name: "Fame Paco Rabanne",
      brand: "Paco Rabanne",
      image: "https://magicperfume.co/cdn/shop/files/Paco_Rabanne_Fame.png?v=1770285610",
      top_notes: ["Mango", "Bergamotte", "Mandarine"],
      heart_notes: ["Jasmin", "Rose", "Weihrauch"],
      base_notes: ["Sandelholz", "Vanille", "Moschus"],
      description: "Ein lebendiger und moderner Duft, der die Selbstverwirklichung feiert.",
      year: "2022",
      gender: "Female",
      productNumbers: ["498"],
      shopifyProduct: {
        title: "Riecht wie... Fame - No. 498 (w)",
        url: "https://magicperfume.co/products/magic-perfume-no-498w",
        price: "€11.99",
        image: "https://magicperfume.co/cdn/shop/files/Paco_Rabanne_Fame.png?v=1770285610"
      }
    },
    {
      id: "paco_invictus",
      name: "Invictus Paco Rabanne",
      brand: "Paco Rabanne",
      image: "https://magicperfume.co/cdn/shop/files/Paco_Rabanne_Invictus.png?v=1770286917",
      top_notes: ["Grapefruit", "Mandarine", "Meeresnoten"],
      heart_notes: ["Lorbeerblatt", "Jasmin", "Zeder"],
      base_notes: ["Eichenmoos", "Amber", "Patschuli"],
      description: "Ein frischer und kraftvoller Duft für den siegreichen Mann.",
      year: "2013",
      gender: "Male",
      productNumbers: ["228"],
      shopifyProduct: {
        title: "Riecht wie... Invictus - No. 228 (m)",
        url: "https://magicperfume.co/products/magic-perfume-no-228m",
        price: "€11.99",
        image: "https://magicperfume.co/cdn/shop/files/Paco_Rabanne_Invictus.png?v=1770286917"
      }
    },
    {
      id: "paco_pure_xs_for_her",
      name: "Pure XS For Her Paco Rabanne",
      brand: "Paco Rabanne",
      image: "https://magicperfume.co/cdn/shop/files/Paco_Rabanne_XS_For_Her.jpg?v=1772105675",
      top_notes: ["Ingwer", "Mandarine", "Passionsfrucht"],
      heart_notes: ["Jasmin", "Orangenblüte", "Ylang-Ylang"],
      base_notes: ["Vanille", "Patschuli", "Moschus"],
      description: "Ein verführerischer und intensiver Duft für die mutige Frau.",
      year: "2017",
      gender: "Female",
      productNumbers: ["050"],
      shopifyProduct: {
        title: "Riecht wie... Pure XS For Her - No. 050 (w)",
        url: "https://magicperfume.co/products/magic-perfume-no-050w",
        price: "€11.99",
        image: "https://magicperfume.co/cdn/shop/files/Paco_Rabanne_XS_For_Her.jpg?v=1772105675"
      }
    },
    {
      id: "paco_olympea_intense",
      name: "Olympea Intense Paco Rabanne",
      brand: "Paco Rabanne",
      image: "https://magicperfume.co/cdn/shop/files/Paco_Rabanne_Olympea_INTENSE.jpg?v=1772108016",
      top_notes: ["Mandarine", "Ingwer", "Wassernoten"],
      heart_notes: ["Jasmin", "Salbei", "Seerose"],
      base_notes: ["Amber", "Moschus", "Sandelholz"],
      description: "Eine intensivere und sinnlichere Version des ikonischen Olympea.",
      year: "2018",
      gender: "Female",
      productNumbers: ["095"],
      shopifyProduct: {
        title: "Riecht wie... Olympea Intense - No. 095 (w)",
        url: "https://magicperfume.co/products/magic-perfume-no-095w",
        price: "€11.99",
        image: "https://magicperfume.co/cdn/shop/files/Paco_Rabanne_Olympea_INTENSE.jpg?v=1772108016"
      }
    },
    {
      id: "paco_phantom",
      name: "Phantom Paco Rabanne",
      brand: "Paco Rabanne",
      image: "https://magicperfume.co/cdn/shop/files/Paco_Rabanne_Phantom.png?v=1770580078",
      top_notes: ["Zitrone", "Bergamotte", "Lavendel"],
      heart_notes: ["Salbei", "Vetiver", "Patschuli"],
      base_notes: ["Vanille", "Amber", "Zeder"],
      description: "Ein futuristischer und vernetzter Duft für eine neue Generation.",
      year: "2021",
      gender: "Male",
      productNumbers: ["399"],
      shopifyProduct: {
        title: "Riecht wie... Phantom - No. 399 (m)",
        url: "https://magicperfume.co/products/magic-perfume-no-399m",
        price: "€11.99",
        image: "https://magicperfume.co/cdn/shop/files/Paco_Rabanne_Phantom.png?v=1770580078"
      }
    }
  ],

  // ===== JEAN PAUL GAULTIER =====
  jpg: [
    {
      id: "jpg_scandal",
      name: "Scandal Jean Paul Gaultier",
      brand: "Jean Paul Gaultier",
      image: "https://magicperfume.co/cdn/shop/files/Jean_Paul_Gaultier_SCANDAL.png?v=1770223879",
      top_notes: ["Mandarine", "Gardenie", "Blutorange"],
      heart_notes: ["Honig", "Jasmin", "Rose"],
      base_notes: ["Patschuli", "Tonkabohne", "Zeder"],
      description: "Ein kühner und verspielter Duft mit einem gourmandigen Herzen.",
      year: "2017",
      gender: "Female",
      productNumbers: ["192"],
      shopifyProduct: {
        title: "Riecht wie... SCANDAL - No. 192 (w)",
        url: "https://magicperfume.co/products/magic-perfume-no-192w",
        price: "€11.99",
        image: "https://magicperfume.co/cdn/shop/files/Jean_Paul_Gaultier_SCANDAL.png?v=1770223879"
      }
    },
    {
      id: "jpg_la_belle",
      name: "La Belle Jean Paul Gaultier",
      brand: "Jean Paul Gaultier",
      image: "https://magicperfume.co/cdn/shop/files/Jean_Paul_Gaultier_La_Belle.png?v=1770286342",
      top_notes: ["Birne", "Bergamotte"],
      heart_notes: ["Jasmin", "Orangenblüte"],
      base_notes: ["Vanille", "Tonkabohne", "Zeder"],
      description: "Ein verführerischer und süchtig machender Gourmand-Duft.",
      year: "2019",
      gender: "Female",
      productNumbers: ["412"],
      shopifyProduct: {
        title: "Riecht wie... La Belle - No. 412 (w)",
        url: "https://magicperfume.co/products/magic-perfume-no-412w",
        price: "€20.99",
        image: "https://magicperfume.co/cdn/shop/files/Jean_Paul_Gaultier_La_Belle.png?v=1770286342"
      }
    },
    {
      id: "jpg_ultra_male",
      name: "Ultra Male Jean Paul Gaultier",
      brand: "Jean Paul Gaultier",
      image: "https://magicperfume.co/cdn/shop/files/Jean_Paul_Gaultier_Ultra_Male.png?v=1770285911",
      top_notes: ["Birne", "Minze", "Lavendel"],
      heart_notes: ["Zimt", "Salbei", "Muskatellersalbei"],
      base_notes: ["Vanille", "Amber", "Holzige Noten"],
      description: "Ein kraftvoller und verführerischer Duft, der die Grenzen der Männlichkeit erweitert.",
      year: "2015",
      gender: "Male",
      productNumbers: ["349"],
      shopifyProduct: {
        title: "Riecht wie... Ultra Male - No. 349 (m)",
        url: "https://magicperfume.co/products/magic-perfume-no-349m",
        price: "€11.99",
        image: "https://magicperfume.co/cdn/shop/files/Jean_Paul_Gaultier_Ultra_Male.png?v=1770285911"
      }
    },
    {
      id: "jpg_classique_essence",
      name: "Classique Essence de Parfum Jean Paul Gaultier",
      brand: "Jean Paul Gaultier",
      image: "https://magicperfume.co/cdn/shop/files/Jean_Paul_Gaultier_Classique_Essence_de_Parfum.png?v=1770290311",
      top_notes: ["Rose", "Ingwer", "Bergamotte"],
      heart_notes: ["Tuberose", "Jasmin", "Orangenblüte"],
      base_notes: ["Vanille", "Amber", "Moschus"],
      description: "Eine intensivere und sinnlichere Interpretation des ikonischen Classique.",
      year: "2013",
      gender: "Female",
      productNumbers: ["442"],
      shopifyProduct: {
        title: "Riecht wie... Classique Essence de Parfum - No. 442 (w)",
        url: "https://magicperfume.co/products/magic-perfume-no-442w",
        price: "€11.99",
        image: "https://magicperfume.co/cdn/shop/files/Jean_Paul_Gaultier_Classique_Essence_de_Parfum.png?v=1770290311"
      }
    },
    {
      id: "jpg_le_male",
      name: "Le Male Jean Paul Gaultier",
      brand: "Jean Paul Gaultier",
      image: "https://magicperfume.co/cdn/shop/files/J.P._Gaultier_Le_Male.png?v=1770217089",
      top_notes: ["Minze", "Lavendel", "Bergamotte", "Kardamom"],
      heart_notes: ["Zimt", "Orangenblüte", "Kümmel"],
      base_notes: ["Vanille", "Tonkabohne", "Amber", "Zeder"],
      description: "Ein ikonischer und verführerischer Duft für den modernen Mann.",
      year: "1995",
      gender: "Male",
      productNumbers: ["247"],
      shopifyProduct: {
        title: "Riecht wie... Le Male - No. 247 (m)",
        url: "https://magicperfume.co/products/magic-perfume-no-247m",
        price: "€11.99",
        image: "https://magicperfume.co/cdn/shop/files/J.P._Gaultier_Le_Male.png?v=1770217089"
      }
    }
  ],

  // ===== MUGLER =====
  mugler: [
    {
      id: "mugler_angel",
      name: "Angel Mugler",
      brand: "Mugler",
      image: "https://magicperfume.co/cdn/shop/files/Thierry_Mugler_Angel_1992.png?v=1770293282",
      top_notes: ["Zuckerwatte", "Bergamotte", "Ananas", "Kokosnuss"],
      heart_notes: ["Honig", "Rote Beeren", "Pfirsich", "Pflaume", "Aprikose"],
      base_notes: ["Patschuli", "Vanille", "Schokolade", "Karamell"],
      description: "Ein revolutionärer Gourmand-Duft, der die Parfümerie für immer verändert hat.",
      year: "1992",
      gender: "Female",
      productNumbers: ["113"],
      shopifyProduct: {
        title: "Riecht wie... Angel - No. 113 (w)",
        url: "https://magicperfume.co/products/magic-perfume-no-113w",
        price: "€11.99",
        image: "https://magicperfume.co/cdn/shop/files/Thierry_Mugler_Angel_1992.png?v=1770293282"
      }
    },
    {
      id: "mugler_angel_nova",
      name: "Angel Nova Mugler",
      brand: "Mugler",
      image: "https://magicperfume.co/cdn/shop/files/Thierry_Mugler_Angel_Nova.webp?v=1771649097",
      top_notes: ["Himbeere", "Litschi", "Bergamotte"],
      heart_notes: ["Rose", "Damascus-Rose", "Jasmin"],
      base_notes: ["Akigalawood", "Benzoin", "Vanille"],
      description: "Eine strahlende und fruchtige Interpretation des ikonischen Angel.",
      year: "2020",
      gender: "Female",
      productNumbers: ["166"],
      shopifyProduct: {
        title: "Riecht wie... Angel Nova - No. 166 (w)",
        url: "https://magicperfume.co/products/magic-perfume-no-166w",
        price: "€11.99",
        image: "https://magicperfume.co/cdn/shop/files/Thierry_Mugler_Angel_Nova.webp?v=1771649097"
      }
    },
    {
      id: "mugler_a_men",
      name: "A*Men Mugler",
      brand: "Mugler",
      image: "https://magicperfume.co/cdn/shop/files/A_Men.webp?v=1772141383",
      top_notes: ["Minze", "Lavendel", "Koriander"],
      heart_notes: ["Honig", "Karamell", "Patschuli"],
      base_notes: ["Vanille", "Moschus", "Amber"],
      description: "Ein kühner und gourmandiger Duft für den selbstbewussten Mann.",
      year: "1996",
      gender: "Male",
      productNumbers: ["255"],
      shopifyProduct: {
        title: "Riecht wie... A*Men - No. 255 (m)",
        url: "https://magicperfume.co/products/magic-perfume-no-255m",
        price: "€11.99",
        image: "https://magicperfume.co/cdn/shop/files/A_Men.webp?v=1772141383"
      }
    }
  ],

  // ===== TOM FORD =====
  tomFord: [
    {
      id: "tomford_vanille_fatale",
      name: "Vanille Fatale Tom Ford",
      brand: "Tom Ford",
      image: "https://magicperfume.co/cdn/shop/files/vanille_fatale.png?v=1772096768",
      top_notes: ["Safran", "Neroli", "Bergamotte"],
      heart_notes: ["Vanille", "Kaffee", "Leder"],
      base_notes: ["Amber", "Myrrhe", "Benzoin"],
      description: "Ein dunkler und berauschender Vanilleduft.",
      year: "2017",
      gender: "Unisex",
      productNumbers: ["053"],
      shopifyProduct: {
        title: "Riecht wie... Vanille Fatale - No. 053 (unisex)",
        url: "https://magicperfume.co/products/magic-perfume-no-053w",
        price: "€11.99",
        image: "https://magicperfume.co/cdn/shop/files/vanille_fatale.png?v=1772096768"
      }
    },
    {
      id: "tomford_lost_cherry",
      name: "Lost Cherry Tom Ford",
      brand: "Tom Ford",
      image: "https://magicperfume.co/cdn/shop/files/Tom_Ford_Lost_Cherry.png?v=1770283537",
      top_notes: ["Kirsche", "Mandel", "Likör"],
      heart_notes: ["Kirsche", "Rose", "Jasmin"],
      base_notes: ["Perubalsam", "Benzoin", "Vanille", "Zeder"],
      description: "Ein verführerischer und verspielter Duft, der die Essenz einer verbotenen Frucht einfängt.",
      year: "2018",
      gender: "Unisex",
      productNumbers: ["438"],
      shopifyProduct: {
        title: "Riecht wie... Lost Cherry - No. 438 (unisex)",
        url: "https://magicperfume.co/products/magic-perfume-no-438w",
        price: "€11.99",
        image: "https://magicperfume.co/cdn/shop/files/Tom_Ford_Lost_Cherry.png?v=1770283537"
      }
    },
    {
      id: "tomford_fucking_fabulous",
      name: "Fucking Fabulous Tom Ford",
      brand: "Tom Ford",
      image: "https://magicperfume.co/cdn/shop/files/Tom_Ford_Fucking_Fabulous_EDP.png?v=1770283980",
      top_notes: ["Salbei", "Lavendel"],
      heart_notes: ["Leder", "Mandel", "Vanille"],
      base_notes: ["Tonka", "Amber", "Holzige Noten"],
      description: "Ein kühner, provokativer Duft mit Leder- und Mandelnoten.",
      year: "2017",
      gender: "Unisex",
      productNumbers: ["232"],
      shopifyProduct: {
        title: "Riecht wie... Fucking Fabulous - No. 232 (unisex)",
        url: "https://magicperfume.co/products/magic-perfume-no-232m",
        price: "€11.99",
        image: "https://magicperfume.co/cdn/shop/files/Tom_Ford_Fucking_Fabulous_EDP.png?v=1770283980"
      }
    },
    {
      id: "tomford_tobacco_vanille",
      name: "Tobacco Vanille Tom Ford",
      brand: "Tom Ford",
      image: "https://magicperfume.co/cdn/shop/files/Tom_Ford_Tobacco_Vanille.png?v=1770290664",
      top_notes: ["Tabakblatt", "Würzige Noten"],
      heart_notes: ["Vanille", "Kakao", "Tonka", "Tabakblüte"],
      base_notes: ["Trockenfrüchte", "Holzige Noten"],
      description: "Ein warmer und würziger Duft mit Tabak- und Vanillenoten.",
      year: "2007",
      gender: "Unisex",
      productNumbers: ["193"],
      shopifyProduct: {
        title: "Riecht wie... Tobacco Vanille - No. 193 (unisex)",
        url: "https://magicperfume.co/products/magic-perfume-no-193m",
        price: "€11.99",
        image: "https://magicperfume.co/cdn/shop/files/Tom_Ford_Tobacco_Vanille.png?v=1770290664"
      }
    },
    {
      id: "tomford_oud_wood",
      name: "Oud Wood Tom Ford",
      brand: "Tom Ford",
      image: "https://magicperfume.co/cdn/shop/files/Tom_Ford_Oud_Wood.png?v=1770289479",
      top_notes: ["Rosenholz", "Kardamom", "Chinesischer Pfeffer"],
      heart_notes: ["Sandelholz", "Vetiver", "Oud"],
      base_notes: ["Tonka", "Amber", "Vanille"],
      description: "Eine geheimnisvolle und exotische Mischung aus seltenem Oud-Holz mit rauchigen Noten.",
      year: "2007",
      gender: "Unisex",
      productNumbers: ["287"],
      shopifyProduct: {
        title: "Riecht wie... Oud Wood - No. 287 (unisex)",
        url: "https://magicperfume.co/products/magic-perfume-no-287m",
        price: "€11.99",
        image: "https://magicperfume.co/cdn/shop/files/Tom_Ford_Oud_Wood.png?v=1770289479"
      }
    },
    {
      id: "tomford_cherry_smoke",
      name: "Cherry Smoke Tom Ford",
      brand: "Tom Ford",
      image: "https://magicperfume.co/cdn/shop/files/Cherry_Smoke.jpg",
      top_notes: ["Kirsche", "Pfeffer", "Safran"],
      heart_notes: ["Rose", "Jasmin", "Leder"],
      base_notes: ["Vanille", "Amber", "Holz"],
      description: "Ein rauchiger und sinnlicher Kirschduft.",
      year: "2023",
      gender: "Unisex",
      productNumbers: ["434"],
      shopifyProduct: {
        title: "Riecht wie... Cherry Smoke - No. 434 (unisex)",
        url: "https://magicperfume.co/products/magic-perfume-no-434m",
        price: "€11.99",
        image: "https://magicperfume.co/cdn/shop/files/Cherry_Smoke.jpg"
      }
    }
  ],

  // ===== GIORGIO ARMANI =====
  armani: [
    {
      id: "armani_si",
      name: "Si Giorgio Armani",
      brand: "Giorgio Armani",
      image: "https://magicperfume.co/cdn/shop/files/Giorgio_Armani_S.jpg?v=1770285117",
      top_notes: ["Schwarze Johannisbeere", "Birne", "Mandarine"],
      heart_notes: ["Rose", "Freesie", "Maiglöckchen"],
      base_notes: ["Vanille", "Patschuli", "Benzoin"],
      description: "Ein anspruchsvoller und moderner Chypre-Duft, der feminine Stärke feiert.",
      year: "2013",
      gender: "Female",
      productNumbers: ["129"],
      shopifyProduct: {
        title: "Riecht wie... Si - No. 129 (w)",
        url: "https://magicperfume.co/products/magic-perfume-no-129w",
        price: "€11.99",
        image: "https://magicperfume.co/cdn/shop/files/Giorgio_Armani_S.jpg?v=1770285117"
      }
    },
    {
      id: "armani_emporio_she",
      name: "Emporio Armani She Giorgio Armani",
      brand: "Giorgio Armani",
      image: "https://magicperfume.co/cdn/shop/files/Giorgio_Armani_Emporio_She.jpg?v=1770284423",
      top_notes: ["Zitrone", "Bergamotte", "Rose"],
      heart_notes: ["Jasmin", "Pfingstrose", "Maiglöckchen"],
      base_notes: ["Sandelholz", "Moschus", "Vanille"],
      description: "Ein frischer und femininer Duft, der den Geist der modernen Jugend einfängt.",
      year: "1998",
      gender: "Female",
      productNumbers: ["150"],
      shopifyProduct: {
        title: "Riecht wie... Emporio She - No. 150 (w)",
        url: "https://magicperfume.co/products/magic-perfume-no-150w",
        price: "€11.99",
        image: "https://magicperfume.co/cdn/shop/files/Giorgio_Armani_Emporio_She.jpg?v=1770284423"
      }
    },
    {
      id: "armani_emporio_he",
      name: "Emporio Armani He Giorgio Armani",
      brand: "Giorgio Armani",
      image: "https://magicperfume.co/cdn/shop/files/Emporio_He.jpg",
      top_notes: ["Bergamotte", "Mandarine", "Zitrone"],
      heart_notes: ["Jasmin", "Rosmarin", "Salbei"],
      base_notes: ["Zeder", "Moschus", "Amber"],
      description: "Ein frischer und maskuliner Duft für den modernen Mann.",
      year: "1998",
      gender: "Male",
      productNumbers: ["242"],
      shopifyProduct: {
        title: "Riecht wie... Emporio He - No. 242 (m)",
        url: "https://magicperfume.co/products/magic-perfume-no-242m",
        price: "€11.99",
        image: "https://magicperfume.co/cdn/shop/files/Emporio_He.jpg"
      }
    },
    {
      id: "armani_my_way",
      name: "My Way Giorgio Armani",
      brand: "Giorgio Armani",
      image: "https://magicperfume.co/cdn/shop/files/Giorgio_Armani_MY_WAY.jpg?v=1770291090",
      top_notes: ["Orangenblüte", "Bergamotte"],
      heart_notes: ["Tuberose", "Jasmin"],
      base_notes: ["Vanille", "Zeder", "Weißer Moschus"],
      description: "Ein strahlender und ethischer Duft, der Authentizität und Verbundenheit feiert.",
      year: "2020",
      gender: "Female",
      productNumbers: ["140"],
      shopifyProduct: {
        title: "Riecht wie... MY WAY - No. 140 (w)",
        url: "https://magicperfume.co/products/magic-perfume-no-140w",
        price: "€11.99",
        image: "https://magicperfume.co/cdn/shop/files/Giorgio_Armani_MY_WAY.jpg?v=1770291090"
      }
    },
    {
      id: "armani_code",
      name: "Code Giorgio Armani",
      brand: "Giorgio Armani",
      image: "https://magicperfume.co/cdn/shop/files/Giorgio_Armani_Armani_Code.png?v=1770220395",
      top_notes: ["Bergamotte", "Zitrone", "Grüne Noten"],
      heart_notes: ["Olivenblüte", "Jasmin", "Orangenblüte"],
      base_notes: ["Leder", "Zeder", "Tonkabohne"],
      description: "Ein anspruchsvoller und verführerischer Duft für den modernen Mann.",
      year: "2004",
      gender: "Male",
      productNumbers: ["260"],
      shopifyProduct: {
        title: "Riecht wie... Armani Code - No. 260 (m)",
        url: "https://magicperfume.co/products/magic-perfume-no-260m",
        price: "€11.99",
        image: "https://magicperfume.co/cdn/shop/files/Giorgio_Armani_Armani_Code.png?v=1770220395"
      }
    },
    {
      id: "armani_code_for_woman",
      name: "Armani Code for Woman Giorgio Armani",
      brand: "Giorgio Armani",
      image: "https://magicperfume.co/cdn/shop/files/Giorgio_Armani_Code_for_Woman.jpg?v=1771252264",
      top_notes: ["Orangenblüte", "Jasmin", "Bergamotte"],
      heart_notes: ["Honig", "Mandel", "Ingwer"],
      base_notes: ["Vanille", "Sandelholz", "Moschus"],
      description: "Ein verführerischer und eleganter orientalischer Blumenduft für Frauen.",
      year: "2006",
      gender: "Female",
      productNumbers: ["135"],
      shopifyProduct: {
        title: "Riecht wie... Code for Woman - No. 135 (w)",
        url: "https://magicperfume.co/products/magic-perfume-no-135w",
        price: "€11.99",
        image: "https://magicperfume.co/cdn/shop/files/Giorgio_Armani_Code_for_Woman.jpg?v=1771252264"
      }
    },
    {
      id: "armani_acqua_di_gio",
      name: "Acqua Di Gio Giorgio Armani",
      brand: "Giorgio Armani",
      image: "https://magicperfume.co/cdn/shop/files/Giorgio_Armani_Acqua_Di_Gio.png?v=1770290000",
      top_notes: ["Bergamotte", "Neroli", "Grüne Mandarine"],
      heart_notes: ["Jasmin", "Rosmarin", "Salbei"],
      base_notes: ["Zeder", "Patschuli", "Moschus"],
      description: "Ein zeitloser aquatischer Klassiker, der die Essenz des Mittelmeers einfängt.",
      year: "1996",
      gender: "Male",
      productNumbers: ["221"],
      shopifyProduct: {
        title: "Riecht wie... Acqua di Gio - No. 221 (m)",
        url: "https://magicperfume.co/products/magic-perfume-no-221m",
        price: "€11.99",
        image: "https://magicperfume.co/cdn/shop/files/Giorgio_Armani_Acqua_Di_Gio.png?v=1770290000"
      }
    },
    {
      id: "armani_acqua_di_gioia",
      name: "Acqua di Gioia Giorgio Armani",
      brand: "Giorgio Armani",
      image: "https://magicperfume.co/cdn/shop/files/Acqua_di_Gioia.webp?v=1772136136",
      top_notes: ["Minze", "Zitrone", "Bergamotte"],
      heart_notes: ["Jasmin", "Pfingstrose", "Freesie"],
      base_notes: ["Zeder", "Moschus", "Brauner Zucker"],
      description: "Ein frischer und aquatischer Duft für Frauen, der die Essenz des Meeres einfängt.",
      year: "2010",
      gender: "Female",
      productNumbers: ["146"],
      shopifyProduct: {
        title: "Riecht wie... Acqua di Gioia - No. 146 (w)",
        url: "https://magicperfume.co/products/magic-perfume-no-146w",
        price: "€11.99",
        image: "https://magicperfume.co/cdn/shop/files/Acqua_di_Gioia.webp?v=1772136136"
      }
    },
    {
      id: "armani_stronger_with_you_intensely",
      name: "Stronger With You Intensely Giorgio Armani",
      brand: "Giorgio Armani",
      image: "https://magicperfume.co/cdn/shop/files/Emporio_Armani_Stronger_With_You_Intensely.png?v=1770287057",
      top_notes: ["Rosa Pfeffer", "Kardamom", "Veilchenblatt"],
      heart_notes: ["Salbei", "Lavendel", "Zimt"],
      base_notes: ["Vanille", "Kastanie", "Tonkabohne", "Amber"],
      description: "Eine intensivere und kraftvollere Interpretation von Stronger With You.",
      year: "2019",
      gender: "Male",
      productNumbers: ["318"],
      shopifyProduct: {
        title: "Riecht wie... Stronger With You Intensely - No. 318 (m)",
        url: "https://magicperfume.co/products/magic-perfume-no-318m",
        price: "€11.99",
        image: "https://magicperfume.co/cdn/shop/files/Emporio_Armani_Stronger_With_You_Intensely.png?v=1770287057"
      }
    },
    {
      id: "armani_diamonds",
      name: "Armani Diamonds Giorgio Armani",
      brand: "Giorgio Armani",
      image: "https://magicperfume.co/cdn/shop/files/Giorgio_Armani_Emporio_Armani_Diamonds.png?v=1770924117",
      top_notes: ["Mandarine", "Bergamotte", "Orange"],
      heart_notes: ["Rose", "Jasmin", "Ylang-Ylang"],
      base_notes: ["Sandelholz", "Moschus", "Amber"],
      description: "Ein funkelnder und eleganter Duft, der die Brillanz von Diamanten einfängt.",
      year: "2000",
      gender: "Female",
      productNumbers: ["040"],
      shopifyProduct: {
        title: "Riecht wie... Armani Diamonds - No. 040 (w)",
        url: "https://magicperfume.co/products/magic-perfume-no-040w",
        price: "€11.99",
        image: "https://magicperfume.co/cdn/shop/files/Giorgio_Armani_Emporio_Armani_Diamonds.png?v=1770924117"
      }
    },
    {
      id: "armani_code_sport",
      name: "Armani Code Sport Giorgio Armani",
      brand: "Giorgio Armani",
      image: "https://magicperfume.co/cdn/shop/files/Armani_Code_Sport.webp?v=1772137221",
      top_notes: ["Bergamotte", "Zitrone", "Grapefruit"],
      heart_notes: ["Guarana", "Muskatnuss", "Zeder"],
      base_notes: ["Tonkabohne", "Vanille", "Amber"],
      description: "Ein frischer und energetischer Duft für den aktiven Mann.",
      year: "2017",
      gender: "Male",
      productNumbers: ["267"],
      shopifyProduct: {
        title: "Riecht wie... Armani Code Sport - No.267 (m)",
        url: "https://magicperfume.co/products/magic-perfume-no-267m",
        price: "€11.99",
        image: "https://magicperfume.co/cdn/shop/files/Armani_Code_Sport.webp?v=1772137221"
      }
    },
    {
      id: "armani_si_passione",
      name: "Si Passione Giorgio Armani",
      brand: "Giorgio Armani",
      image: "https://magicperfume.co/cdn/shop/files/Si_Passione.webp?v=1772143097",
      top_notes: ["Schwarze Johannisbeere", "Birne", "Mandarine"],
      heart_notes: ["Rose", "Jasmin", "Pfingstrose"],
      base_notes: ["Vanille", "Patschuli", "Zeder"],
      description: "Ein leidenschaftlicher und intensiver Duft für die moderne Frau.",
      year: "2017",
      gender: "Female",
      productNumbers: ["100"],
      shopifyProduct: {
        title: "Riecht wie... Si Passione - No. 100 (w)",
        url: "https://magicperfume.co/products/magic-perfume-no-100w",
        price: "€11.99",
        image: "https://magicperfume.co/cdn/shop/files/Si_Passione.webp?v=1772143097"
      }
    },
    {
      id: "armani_terra_di_gioia",
      name: "Terra Di Gioia Giorgio Armani",
      brand: "Giorgio Armani",
      image: "https://magicperfume.co/cdn/shop/files/Terra_di_Gioia.webp?v=1772139466",
      top_notes: ["Bergamotte", "Orange", "Mandarine"],
      heart_notes: ["Jasmin", "Rose", "Ylang-Ylang"],
      base_notes: ["Vanille", "Sandelholz", "Moschus"],
      description: "Ein warmer und sinnlicher Duft, der die Essenz der Erde einfängt.",
      year: "2015",
      gender: "Female",
      productNumbers: ["436"],
      shopifyProduct: {
        title: "Riecht wie... Terra Di Gioia - No. 436 (w)",
        url: "https://magicperfume.co/products/magic-perfume-no-436w",
        price: "€11.99",
        image: "https://magicperfume.co/cdn/shop/files/Terra_di_Gioia.webp?v=1772139466"
      }
    },
    {
      id: "armani_profumo",
      name: "Acqua Di Gio Profumo Giorgio Armani",
      brand: "Giorgio Armani",
      image: "https://magicperfume.co/cdn/shop/files/Acqua_Di_Gio_Profumo.webp?v=1772140413",
      top_notes: ["Bergamotte", "Mandarine", "Meeresnoten"],
      heart_notes: ["Rosmarin", "Salbei", "Geranie"],
      base_notes: ["Weihrauch", "Patschuli", "Zeder"],
      description: "Eine intensivere und tiefere Interpretation des ikonischen Acqua Di Gio.",
      year: "2015",
      gender: "Male",
      productNumbers: ["296"],
      shopifyProduct: {
        title: "Riecht wie... Profumo - No. 296 (m)",
        url: "https://magicperfume.co/products/magic-perfume-no-296m",
        price: "€11.99",
        image: "https://magicperfume.co/cdn/shop/files/Acqua_Di_Gio_Profumo.webp?v=1772140413"
      }
    }
  ],

  // ===== DIOR =====
  dior: [
    {
      id: "dior_sauvage_parfum",
      name: "Sauvage Parfum Dior",
      brand: "Dior",
      image: "https://magicperfume.co/cdn/shop/files/Dior_Sauvage.png?v=1770220271",
      top_notes: ["Bergamotte", "Mandarine"],
      heart_notes: ["Lavendel", "Sternanis", "Muskatnuss"],
      base_notes: ["Sandelholz", "Vanille", "Amber"],
      description: "Eine tiefere, intensivere Interpretation von Sauvage.",
      year: "2018",
      gender: "Male",
      productNumbers: ["338"],
      shopifyProduct: {
        title: "Riecht wie... Sauvage Parfum - No. 338 (m)",
        url: "https://magicperfume.co/products/magic-perfume-no-338m",
        price: "€11.99",
        image: "https://magicperfume.co/cdn/shop/files/Dior_Sauvage.png?v=1770220271"
      }
    },
    {
      id: "dior_sauvage_elixir",
      name: "Sauvage Elixir Dior",
      brand: "Dior",
      image: "https://magicperfume.co/cdn/shop/files/Dior_Sauvage_Elixir.png?v=1770218137",
      top_notes: ["Grapefruit", "Muskatnuss", "Zimt"],
      heart_notes: ["Lavendel", "Sternanis", "Koriander"],
      base_notes: ["Lakritze", "Patschuli", "Sandelholz"],
      description: "Eine kühne und intensive Neuinterpretation von Sauvage.",
      year: "2021",
      gender: "Male",
      productNumbers: ["366"],
      shopifyProduct: {
        title: "Riecht wie... Sauvage Elixir - No. 366 (m)",
        url: "https://magicperfume.co/products/magic-perfume-no-366m",
        price: "€11.99",
        image: "https://magicperfume.co/cdn/shop/files/Dior_Sauvage_Elixir.png?v=1770218137"
      }
    },
    {
      id: "dior_hypnotic_poison",
      name: "Hypnotic Poison Dior",
      brand: "Dior",
      image: "https://magicperfume.co/cdn/shop/files/Hypnotic_Poison.png?v=1771366694",
      top_notes: ["Aprikose", "Pflaume", "Kokosnuss", "Bittermandel"],
      heart_notes: ["Rose", "Jasmin", "Maiglöckchen"],
      base_notes: ["Vanille", "Mandel", "Moschus"],
      description: "Ein geheimnisvoller und sinnlicher Duft, der einen Zauber der Verführung webt.",
      year: "1998",
      gender: "Female",
      productNumbers: ["145"],
      shopifyProduct: {
        title: "Riecht wie... Hypnotic Poison - No. 145 (w)",
        url: "https://magicperfume.co/products/magic-perfume-no-145w",
        price: "€11.99",
        image: "https://magicperfume.co/cdn/shop/files/Hypnotic_Poison.png?v=1771366694"
      }
    },
    {
      id: "dior_jadore",
      name: "J'adore Dior",
      brand: "Dior",
      image: "https://magicperfume.co/cdn/shop/files/Christian_Dior_J_adore.jpg?v=1770220853",
      top_notes: ["Birne", "Melone", "Pfirsich", "Magnolie"],
      heart_notes: ["Jasmin", "Rose", "Maiglöckchen", "Ylang-Ylang"],
      base_notes: ["Vanille", "Moschus", "Zeder"],
      description: "Ein blumiger Strauß von außergewöhnlicher Fülle.",
      year: "1999",
      gender: "Female",
      productNumbers: ["159"],
      shopifyProduct: {
        title: "Riecht wie... J'Adore - No. 159 (w)",
        url: "https://magicperfume.co/products/magic-perfume-no-159w",
        price: "€11.99",
        image: "https://magicperfume.co/cdn/shop/files/Christian_Dior_J_adore.jpg?v=1770220853"
      }
    },
    {
      id: "dior_miss_dior_le_parfum",
      name: "Miss Dior Le Parfum Dior",
      brand: "Dior",
      image: "https://magicperfume.co/cdn/shop/files/Christian_Dior_Miss_Dior_Le_Parfum.jpg?v=1770293457",
      top_notes: ["Lavendel", "Bergamotte", "Salbei"],
      heart_notes: ["Iris", "Moschus", "Ambrette", "Birne"],
      base_notes: ["Virginische Zeder", "Vetiver", "Leder", "Amber Accord"],
      description: "Die konzentrierteste und luxuriöseste Version von Dior Homme.",
      year: "2025",
      gender: "Female",
      productNumbers: ["196"],
      shopifyProduct: {
        title: "Riecht wie... Miss Dior Le Parfum - No. 196 (w)",
        url: "https://magicperfume.co/products/magic-perfume-no-196w",
        price: "€11.99",
        image: "https://magicperfume.co/cdn/shop/files/Christian_Dior_Miss_Dior_Le_Parfum.jpg?v=1770293457"
      }
    },
    {
      id: "dior_fahrenheit",
      name: "Fahrenheit Dior",
      brand: "Dior",
      image: "https://magicperfume.co/cdn/shop/files/Christian_Dior_Fahrenheit.png?v=1770289652",
      top_notes: ["Weißdorn", "Zeder", "Beifuß", "Muskatnuss", "Mandarine"],
      heart_notes: ["Leder", "Veilchen", "Geißblatt"],
      base_notes: ["Leder", "Vetiver", "Amber"],
      description: "Ein revolutionärer Duft, der blumige, holzige und ledrige Noten vereint.",
      year: "1988",
      gender: "Male",
      productNumbers: ["206"],
      shopifyProduct: {
        title: "Riecht wie... Fahrenheit - No. 206 (m)",
        url: "https://magicperfume.co/products/magic-perfume-no-206m",
        price: "€11.99",
        image: "https://magicperfume.co/cdn/shop/files/Christian_Dior_Fahrenheit.png?v=1770289652"
      }
    },
    {
      id: "dior_fahrenheit_le_parfum",
      name: "Fahrenheit Le Parfum Dior",
      brand: "Dior",
      image: "https://magicperfume.co/cdn/shop/files/Dior_Fahrenheit_Le_Parfum.jpg?v=1770284765",
      top_notes: ["Veilchen", "Leder", "Weihrauch"],
      heart_notes: ["Leder", "Veilchen", "Geißblatt"],
      base_notes: ["Leder", "Vetiver", "Amber", "Myrrhe"],
      description: "Eine tiefere, intensivere Interpretation des ikonischen Fahrenheit.",
      year: "2015",
      gender: "Male",
      productNumbers: ["350"],
      shopifyProduct: {
        title: "Riecht wie... Fahrenheit Le Parfum - No. 350 (m)",
        url: "https://magicperfume.co/products/magic-perfume-no-350m",
        price: "€11.99",
        image: "https://magicperfume.co/cdn/shop/files/Dior_Fahrenheit_Le_Parfum.jpg?v=1770284765"
      }
    },
    {
      id: "dior_homme_intense",
      name: "Dior Homme Intense Dior",
      brand: "Dior",
      image: "https://magicperfume.co/cdn/shop/files/Dior_Homme_Intense.png?v=1770290129",
      top_notes: ["Lavendel"],
      heart_notes: ["Toskanische Iris", "Ambrettasamen", "Birne"],
      base_notes: ["Virginische Zeder", "Vetiver"],
      description: "Ein intensiver und sinnlicher Duft, der die Männlichkeit betont.",
      year: "2011",
      gender: "Male",
      productNumbers: ["277"],
      shopifyProduct: {
        title: "Riecht wie... Homme Intense - No. 277 (m)",
        url: "https://magicperfume.co/products/magic-perfume-no-277m",
        price: "€11.99",
        image: "https://magicperfume.co/cdn/shop/files/Dior_Homme_Intense.png?v=1770290129"
      }
    },
    {
      id: "dior_miss_cherie",
      name: "Miss Chérie Dior",
      brand: "Dior",
      image: "https://magicperfume.co/cdn/shop/files/Christian_Dior_Miss_Dior_Cherie.jpg?v=1770963606",
      top_notes: ["Erdbeere", "Mandarine", "Rosa Pfeffer"],
      heart_notes: ["Jasmin", "Rose", "Karamell", "Popcorn"],
      base_notes: ["Patschuli", "Moschus", "Zeder"],
      description: "Ein verspielter und romantischer Duft, der den Geist einer jungen Frau in Liebe einfängt.",
      year: "2005",
      gender: "Female",
      productNumbers: ["082"],
      shopifyProduct: {
        title: "Riecht wie... Miss Cherie - No. 082 (w)",
        url: "https://magicperfume.co/products/magic-perfume-no-082w",
        price: "€11.99",
        image: "https://magicperfume.co/cdn/shop/files/Christian_Dior_Miss_Dior_Cherie.jpg?v=1770963606"
      }
    },
    {
      id: "dior_fahrenheit_32",
      name: "Fahrenheit 32 Dior",
      brand: "Dior",
      image: "https://magicperfume.co/cdn/shop/files/Fahrenheit_32.webp?v=1772136282",
      top_notes: ["Mandarine", "Bergamotte", "Muskatnuss"],
      heart_notes: ["Veilchen", "Jasmin", "Orangenblüte"],
      base_notes: ["Vanille", "Sandelholz", "Tonkabohne"],
      description: "Eine frische und moderne Interpretation des ikonischen Fahrenheit.",
      year: "2007",
      gender: "Male",
      productNumbers: ["327"],
      shopifyProduct: {
        title: "Riecht wie... Fahrenheit 32 - No. 327 (m)",
        url: "https://magicperfume.co/products/magic-perfume-no-327m",
        price: "€11.99",
        image: "https://magicperfume.co/cdn/shop/files/Fahrenheit_32.webp?v=1772136282"
      }
    },
    {
      id: "dior_midnight_poison",
      name: "Midnight Poison Dior",
      brand: "Dior",
      image: "https://magicperfume.co/cdn/shop/files/Midnight_Poison.jpg?v=1772105149",
      top_notes: ["Bergamotte", "Mandarine", "Rose"],
      heart_notes: ["Jasmin", "Patschuli", "Amber"],
      base_notes: ["Vanille", "Moschus", "Zeder"],
      description: "Ein geheimnisvoller und verführerischer Duft aus der Poison Kollektion.",
      year: "2007",
      gender: "Female",
      productNumbers: ["044"],
      shopifyProduct: {
        title: "Riecht wie... Midnight Poison - No. 044 (w)",
        url: "https://magicperfume.co/products/magic-perfume-no-044w",
        price: "€11.99",
        image: "https://magicperfume.co/cdn/shop/files/Midnight_Poison.jpg?v=1772105149"
      }
    },
    {
      id: "dior_rose_n_roses",
      name: "Rose N'Roses Dior",
      brand: "Dior",
      image: "https://magicperfume.co/cdn/shop/files/Miss_Dior_Rose_N_Roses.jpg?v=1772106609",
      top_notes: ["Bergamotte", "Zitrone", "Orange"],
      heart_notes: ["Rose", "Jasmin", "Maiglöckchen"],
      base_notes: ["Moschus", "Amber", "Zeder"],
      description: "Ein frischer und romantischer Rosenduft aus der Miss Dior Kollektion.",
      year: "2020",
      gender: "Female",
      productNumbers: ["084"],
      shopifyProduct: {
        title: "Riecht wie... Rose N'Roses - No. 084 (w)",
        url: "https://magicperfume.co/products/magic-perfume-no-084w",
        price: "€11.99",
        image: "https://magicperfume.co/cdn/shop/files/Miss_Dior_Rose_N_Roses.jpg?v=1772106609"
      }
    }
  ],

  // ===== CHANEL =====
  chanel: [
    {
      id: "chanel_bleu",
      name: "Bleu de Chanel",
      brand: "Chanel",
      image: "https://magicperfume.co/cdn/shop/files/Chanel_Bleud.png?v=1770283838",
      top_notes: ["Grapefruit", "Zitrone", "Minze", "Rosa Pfeffer"],
      heart_notes: ["Ingwer", "Muskatnuss", "Jasmin"],
      base_notes: ["Weihrauch", "Vetiver", "Zeder", "Sandelholz"],
      description: "Ein zeitloser und anspruchsvoller Duft für Männer, der den Geist der Freiheit verkörpert.",
      year: "2010",
      gender: "Male",
      productNumbers: ["252"],
      shopifyProduct: {
        title: "Riecht wie... Bleu - No. 252 (m)",
        url: "https://magicperfume.co/products/magic-perfume-no-252m",
        price: "€11.99",
        image: "https://magicperfume.co/cdn/shop/files/Chanel_Bleud.png?v=1770283838"
      }
    },
    {
      id: "chanel_coco",
      name: "Coco Chanel",
      brand: "Chanel",
      image: "https://magicperfume.co/cdn/shop/files/Chanel_Coco.jpg?v=1770285282",
      top_notes: ["Koriander", "Mandarine", "Pfirsich", "Jasmin"],
      heart_notes: ["Rose", "Nelke", "Mimose", "Nelke"],
      base_notes: ["Sandelholz", "Amber", "Opium", "Benzoin"],
      description: "Ein üppiger und sinnlicher orientalischer Duft, der den Geist von Mademoiselle Chanel verkörpert.",
      year: "1984",
      gender: "Female",
      productNumbers: ["079"],
      shopifyProduct: {
        title: "Riecht wie... Coco - No. 079 (w)",
        url: "https://magicperfume.co/products/magic-perfume-no-079w",
        price: "€11.99",
        image: "https://magicperfume.co/cdn/shop/files/Chanel_Coco.jpg?v=1770285282"
      }
    },
    {
      id: "chanel_coco_mademoiselle_intense",
      name: "Coco Mademoiselle Intense Chanel",
      brand: "Chanel",
      image: "https://magicperfume.co/cdn/shop/files/Chanel_Coco_Mademoiselle_Intense.png?v=1770291316",
      top_notes: ["Orange", "Bergamotte", "Grapefruit"],
      heart_notes: ["Rose", "Jasmin", "Litschi"],
      base_notes: ["Patschuli", "Vanille", "Moschus", "Vetiver"],
      description: "Eine intensivere Interpretation des ikonischen Coco Mademoiselle.",
      year: "2018",
      gender: "Female",
      productNumbers: ["067"],
      shopifyProduct: {
        title: "Riecht wie... Mademoiselle Intense - No. 067 (w)",
        url: "https://magicperfume.co/products/magic-perfume-no-067w",
        price: "€11.99",
        image: "https://magicperfume.co/cdn/shop/files/Chanel_Coco_Mademoiselle_Intense.png?v=1770291316"
      }
    },
    {
      id: "chanel_mademoiselle",
      name: "Coco Mademoiselle Chanel",
      brand: "Chanel",
      image: "https://magicperfume.co/cdn/shop/files/0a78ac2c2769df411731eaba9cb8c230.jpg_720x720q80.jpg?v=1772090593",
      top_notes: ["Orange", "Bergamotte", "Grapefruit"],
      heart_notes: ["Rose", "Jasmin", "Litschi"],
      base_notes: ["Patschuli", "Vanille", "Moschus", "Vetiver"],
      description: "Ein frischer und moderner orientalischer Duft, der den Geist einer jungen, selbstbewussten Frau einfängt.",
      year: "2001",
      gender: "Female",
      productNumbers: ["139"],
      shopifyProduct: {
        title: "Riecht wie... Mademoiselle - No. 139 (w)",
        url: "https://magicperfume.co/products/magic-perfume-no-139w",
        price: "€11.99",
        image: "https://magicperfume.co/cdn/shop/files/0a78ac2c2769df411731eaba9cb8c230.jpg_720x720q80.jpg?v=1772090593"
      }
    },
    {
      id: "chanel_chance",
      name: "Chance Chanel",
      brand: "Chanel",
      image: "https://magicperfume.co/cdn/shop/files/Chanel_Chance.png?v=1770923697",
      top_notes: ["Rosa Pfeffer", "Quitte", "Zitrusfrüchte"],
      heart_notes: ["Hyazinthe", "Jasmin", "Iris"],
      base_notes: ["Moschus", "Patschuli", "Vetiver", "Zeder"],
      description: "Ein lebendiger und unerwarteter Blumenduft.",
      year: "2003",
      gender: "Female",
      productNumbers: ["006"],
      shopifyProduct: {
        title: "Riecht wie... Chance - No. 006 (w)",
        url: "https://magicperfume.co/products/magic-perfume-no-006w",
        price: "€11.99",
        image: "https://magicperfume.co/cdn/shop/files/Chanel_Chance.png?v=1770923697"
      }
    },
    {
      id: "chanel_no5",
      name: "No. 5 Chanel",
      brand: "Chanel",
      image: "https://magicperfume.co/cdn/shop/files/Chanel.jpg?v=1771891018",
      top_notes: ["Aldehyde", "Ylang-Ylang", "Neroli", "Bergamotte"],
      heart_notes: ["Iris", "Jasmin", "Rose", "Maiglöckchen"],
      base_notes: ["Vanille", "Amber", "Sandelholz", "Vetiver", "Moschus"],
      description: "Der legendärste Duft der Welt, Chanel No 5 ist ein abstrakter blumiger Aldehyd, der die Parfümerie revolutionierte.",
      year: "1921",
      gender: "Female",
      productNumbers: ["077"],
      shopifyProduct: {
        title: "Riecht wie... No.5 - No. 077 (w)",
        url: "https://magicperfume.co/products/magic-perfume-no-077w",
        price: "€11.99",
        image: "https://magicperfume.co/cdn/shop/files/Chanel.jpg?v=1771891018"
      }
    },
    {
      id: "chanel_allure_homme",
      name: "Allure Homme Chanel",
      brand: "Chanel",
      image: "https://magicperfume.co/cdn/shop/files/allure_homme.webp?v=1772119802",
      top_notes: ["Bergamotte", "Mandarine", "Zitrone"],
      heart_notes: ["Zeder", "Sandelholz", "Vetiver"],
      base_notes: ["Tonkabohne", "Vanille", "Amber"],
      description: "Ein eleganter und maskuliner Duft für den modernen Mann.",
      year: "1999",
      gender: "Male",
      productNumbers: ["240"],
      shopifyProduct: {
        title: "Riecht wie... Allure Homme - No. 240 (m)",
        url: "https://magicperfume.co/products/magic-perfume-no-240m",
        price: "€11.99",
        image: "https://magicperfume.co/cdn/shop/files/allure_homme.webp?v=1772119802"
      }
    },
    {
      id: "chanel_allure_homme_sport",
      name: "Allure Homme Sport Chanel",
      brand: "Chanel",
      image: "https://magicperfume.co/cdn/shop/files/allure_homme_sport.webp",
      top_notes: ["Mandarine", "Zitrone", "Bergamotte"],
      heart_notes: ["Pfeffer", "Zeder", "Meeresnoten"],
      base_notes: ["Moschus", "Amber", "Tonkabohne"],
      description: "Ein frischer und sportlicher Duft für den dynamischen Mann.",
      year: "2004",
      gender: "Male",
      productNumbers: ["222"],
      shopifyProduct: {
        title: "Riecht wie... Allure Homme Sport - No. 222 (m)",
        url: "https://magicperfume.co/products/magic-perfume-no-222m",
        price: "€11.99",
        image: "https://magicperfume.co/cdn/shop/files/allure_homme_sport.webp"
      }
    },
    {
      id: "chanel_bois_des_iles",
      name: "Bois des Iles Chanel",
      brand: "Chanel",
      image: "https://magicperfume.co/cdn/shop/files/Bois_des_Iles.webp?v=1772140695",
      top_notes: ["Bergamotte", "Mandarine", "Neroli"],
      heart_notes: ["Jasmin", "Rose", "Ylang-Ylang"],
      base_notes: ["Sandelholz", "Vanille", "Amber"],
      description: "Ein holziger und sinnlicher Duft, der die Essenz exotischer Inseln einfängt.",
      year: "1926",
      gender: "Unisex",
      productNumbers: ["459"],
      shopifyProduct: {
        title: "Riecht wie... Bois des Iles - No. 459 (unisex)",
        url: "https://magicperfume.co/products/magic-perfume-no-459m",
        price: "€11.99",
        image: "https://magicperfume.co/cdn/shop/files/Bois_des_Iles.webp?v=1772140695"
      }
    }
  ],

  // ===== HUGO BOSS =====
  hugoBoss: [
    {
      id: "boss_woman",
      name: "Boss Woman Hugo Boss",
      brand: "Hugo Boss",
      image: "https://magicperfume.co/cdn/shop/files/Boss_Woman.jpg?v=1770925272",
      top_notes: ["Mandarine", "Apfel", "Pfirsich"],
      heart_notes: ["Rose", "Jasmin", "Lilie"],
      base_notes: ["Sandelholz", "Moschus", "Vanille"],
      description: "Ein klassischer und eleganter Duft für die erfolgreiche moderne Frau.",
      year: "2000",
      gender: "Female",
      productNumbers: ["060"],
      shopifyProduct: {
        title: "Riecht wie... Boss Woman - No. 060 (w)",
        url: "https://magicperfume.co/products/magic-perfume-no-060w",
        price: "€11.99",
        image: "https://magicperfume.co/cdn/shop/files/Boss_Woman.jpg?v=1770925272"
      }
    },
    {
      id: "boss_bottled",
      name: "Boss Bottled Hugo Boss",
      brand: "Hugo Boss",
      image: "https://magicperfume.co/cdn/shop/files/Hugo_Boss_Bottled.png?v=1770223505",
      top_notes: ["Apfel", "Zitrusfrüchte", "Geranie"],
      heart_notes: ["Zeder", "Sandelholz", "Patschuli"],
      base_notes: ["Vanille", "Moschus", "Amber"],
      description: "Ein klassischer und anspruchsvoller Duft für den erfolgreichen modernen Mann.",
      year: "1998",
      gender: "Male",
      productNumbers: ["234"],
      shopifyProduct: {
        title: "Riecht wie... Bottled - No. 234 (m)",
        url: "https://magicperfume.co/products/magic-perfume-no-234m",
        price: "€11.99",
        image: "https://magicperfume.co/cdn/shop/files/Hugo_Boss_Bottled.png?v=1770223505"
      }
    },
    {
      id: "boss_bottled_intense",
      name: "Boss Bottled Intense Hugo Boss",
      brand: "Hugo Boss",
      image: "https://magicperfume.co/cdn/shop/files/Boss_Bottled_Intense.webp?v=1772139127",
      top_notes: ["Apfel", "Zitrone", "Bergamotte"],
      heart_notes: ["Zimt", "Nelke", "Sandelholz"],
      base_notes: ["Vanille", "Amber", "Moschus"],
      description: "Eine intensivere und wärmere Version des ikonischen Boss Bottled.",
      year: "2018",
      gender: "Male",
      productNumbers: ["346"],
      shopifyProduct: {
        title: "Riecht wie... Bottled Intense - No. 346 (m)",
        url: "https://magicperfume.co/products/magic-perfume-no-346m",
        price: "€11.99",
        image: "https://magicperfume.co/cdn/shop/files/Boss_Bottled_Intense.webp?v=1772139127"
      }
    },
    {
      id: "boss_hugo",
      name: "Hugo Hugo Boss",
      brand: "Hugo Boss",
      image: "https://magicperfume.co/cdn/shop/files/Hugo_Boss_Hugo.png?v=1770292811",
      top_notes: ["Grüne Noten", "Basilikum", "Minze"],
      heart_notes: ["Lavendel", "Geranie", "Muskatellersalbei"],
      base_notes: ["Zeder", "Sandelholz", "Moschus"],
      description: "Ein frischer und energetischer Duft für den jungen und dynamischen Mann.",
      year: "1995",
      gender: "Male",
      productNumbers: ["223"],
      shopifyProduct: {
        title: "Riecht wie... Hugo - No. 223 (m)",
        url: "https://magicperfume.co/products/magic-perfume-no-223m",
        price: "€11.99",
        image: "https://magicperfume.co/cdn/shop/files/Hugo_Boss_Hugo.png?v=1770292811"
      }
    },
    {
      id: "boss_orange",
      name: "Boss Orange Hugo Boss",
      brand: "Hugo Boss",
      image: "https://magicperfume.co/cdn/shop/files/Hugo_Boss_Boss_Orange.jpg?v=1770293717",
      top_notes: ["Apfel", "Weiße Blüten", "Zitrusfrüchte"],
      heart_notes: ["Rose", "Jasmin", "Pfingstrose"],
      base_notes: ["Sandelholz", "Moschus", "Vanille"],
      description: "Ein frischer und unbeschwerter Duft für die moderne Frau.",
      year: "2003",
      gender: "Female",
      productNumbers: ["148"],
      shopifyProduct: {
        title: "Riecht wie... Boss Orange - No. 148 (w)",
        url: "https://magicperfume.co/products/magic-perfume-no-148w",
        price: "€11.99",
        image: "https://magicperfume.co/cdn/shop/files/Hugo_Boss_Boss_Orange.jpg?v=1770293717"
      }
    },
    {
      id: "boss_the_scent",
      name: "The Scent Hugo Boss",
      brand: "Hugo Boss",
      image: "https://magicperfume.co/cdn/shop/files/Hugo_Boss_The_Scent.png?v=1770292543",
      top_notes: ["Ingwer", "Bergamotte", "Mandarine"],
      heart_notes: ["Lavendel", "Maninka", "Fruchtnoten"],
      base_notes: ["Leder", "Patschuli", "Zeder"],
      description: "Ein verführerischer und magnetischer Duft, der die Essenz der Anziehung einfängt.",
      year: "2015",
      gender: "Male",
      productNumbers: ["270"],
      shopifyProduct: {
        title: "Riecht wie... The Scent - No. 270 (m)",
        url: "https://magicperfume.co/products/magic-perfume-no-270m",
        price: "€11.99",
        image: "https://magicperfume.co/cdn/shop/files/Hugo_Boss_The_Scent.png?v=1770292543"
      }
    },
    {
      id: "boss_alive",
      name: "Boss Alive Hugo Boss",
      brand: "Hugo Boss",
      image: "https://magicperfume.co/cdn/shop/files/alive.png?v=1772098782",
      top_notes: ["Apfel", "Schwarze Johannisbeere", "Pflaume"],
      heart_notes: ["Rose", "Jasmin", "Zimt"],
      base_notes: ["Vanille", "Moschus", "Zeder"],
      description: "Ein lebendiger und energetischer Duft, der die Freude am Leben feiert.",
      year: "2019",
      gender: "Female",
      productNumbers: ["098"],
      shopifyProduct: {
        title: "Riecht wie... ALIVE - No. 098 (w)",
        url: "https://magicperfume.co/products/magic-perfume-no-098w",
        price: "€11.99",
        image: "https://magicperfume.co/cdn/shop/files/alive.png?v=1772098782"
      }
    },
    {
      id: "boss_ma_vie",
      name: "Ma Vie Hugo Boss",
      brand: "Hugo Boss",
      image: "https://magicperfume.co/cdn/shop/files/Hugo_Boss_Ma_Vie.jpg?v=1770924802",
      top_notes: ["Zitrusfrüchte", "Fruchtnoten", "Bergamotte"],
      heart_notes: ["Rose", "Jasmin", "Maiglöckchen"],
      base_notes: ["Vanille", "Moschus", "Zeder"],
      description: "Ein frischer und eleganter Duft, der die Schönheit des Lebens feiert.",
      year: "2010",
      gender: "Female",
      productNumbers: ["058"],
      shopifyProduct: {
        title: "Riecht wie... Ma Vie - No. 058 (w)",
        url: "https://magicperfume.co/products/magic-perfume-no-058w",
        price: "€11.99",
        image: "https://magicperfume.co/cdn/shop/files/Hugo_Boss_Ma_Vie.jpg?v=1770924802"
      }
    },
    {
      id: "boss_energise",
      name: "Energise Hugo Boss",
      brand: "Hugo Boss",
      image: "https://magicperfume.co/cdn/shop/files/Hugo_Energise.webp?v=1772142991",
      top_notes: ["Grapefruit", "Apfel", "Minze"],
      heart_notes: ["Salbei", "Lavendel", "Geranie"],
      base_notes: ["Zeder", "Moschus", "Amber"],
      description: "Ein energetischer und belebender Duft für den aktiven Mann.",
      year: "2006",
      gender: "Male",
      productNumbers: ["254"],
      shopifyProduct: {
        title: "Riecht wie... Energise - No. 254 (m)",
        url: "https://magicperfume.co/products/magic-perfume-no-254m",
        price: "€11.99",
        image: "https://magicperfume.co/cdn/shop/files/Hugo_Energise.webp?v=1772142991"
      }
    }
  ],

  // ===== CALVIN KLEIN =====
  calvinKlein: [
    {
      id: "ck_eternity",
      name: "Eternity Calvin Klein",
      brand: "Calvin Klein",
      image: "https://magicperfume.co/cdn/shop/files/Calvin_Klein_Eternity.png?v=1770287215",
      top_notes: ["Mandarine", "Bergamotte", "Zitrone"],
      heart_notes: ["Maiglöckchen", "Rose", "Jasmin"],
      base_notes: ["Sandelholz", "Moschus", "Amber"],
      description: "Ein zeitloser und romantischer Duft, der die dauerhafte Liebe feiert.",
      year: "1988",
      gender: "Female",
      productNumbers: ["106"],
      shopifyProduct: {
        title: "Riecht wie... Eternity - No. 106 (w)",
        url: "https://magicperfume.co/products/magic-perfume-no-106w",
        price: "€11.99",
        image: "https://magicperfume.co/cdn/shop/files/Calvin_Klein_Eternity.png?v=1770287215"
      }
    },
    {
      id: "ck_eternity_moment",
      name: "Eternity Moment Calvin Klein",
      brand: "Calvin Klein",
      image: "https://magicperfume.co/cdn/shop/files/Eternity_Moment.webp?v=1772138932",
      top_notes: ["Granatapfel", "Mandarine", "Pfirsich"],
      heart_notes: ["Lilie", "Jasmin", "Rose"],
      base_notes: ["Sandelholz", "Moschus", "Amber"],
      description: "Ein romantischer und femininer Duft für besondere Momente.",
      year: "2008",
      gender: "Female",
      productNumbers: ["414"],
      shopifyProduct: {
        title: "Riecht wie... CK Eternity Moment - No. 414 (w)",
        url: "https://magicperfume.co/products/magic-perfume-no-414w",
        price: "€11.99",
        image: "https://magicperfume.co/cdn/shop/files/Eternity_Moment.webp?v=1772138932"
      }
    },
    {
      id: "ck_euphoria_blossom",
      name: "Euphoria Blossom Calvin Klein",
      brand: "Calvin Klein",
      image: "https://magicperfume.co/cdn/shop/files/Euphoria_Blossom.webp?v=1772137112",
      top_notes: ["Granatapfel", "Kaktusfeige", "Mandarine"],
      heart_notes: ["Orchidee", "Jasmin", "Pfingstrose"],
      base_notes: ["Amber", "Moschus", "Sandelholz"],
      description: "Ein blumiger und fruchtiger Duft für die moderne Frau.",
      year: "2012",
      gender: "Female",
      productNumbers: ["087"],
      shopifyProduct: {
        title: "Riecht wie... Euphoria Blossom - No. 087 (w)",
        url: "https://magicperfume.co/products/magic-perfume-no-087w",
        price: "€11.99",
        image: "https://magicperfume.co/cdn/shop/files/Euphoria_Blossom.webp?v=1772137112"
      }
    },
    {
      id: "ck_one",
      name: "CK One Calvin Klein",
      brand: "Calvin Klein",
      image: "https://magicperfume.co/cdn/shop/files/CK_One.webp?v=1772137544",
      top_notes: ["Bergamotte", "Zitrone", "Grüne Noten"],
      heart_notes: ["Jasmin", "Rose", "Maiglöckchen"],
      base_notes: ["Moschus", "Amber", "Zeder"],
      description: "Ein ikonischer Unisex-Duft, der Frische und Reinheit symbolisiert.",
      year: "1994",
      gender: "Unisex",
      productNumbers: ["209"],
      shopifyProduct: {
        title: "Riecht wie... CK One - No. 209 (unisex)",
        url: "https://magicperfume.co/products/magic-perfume-no-209m",
        price: "€11.99",
        image: "https://magicperfume.co/cdn/shop/files/CK_One.webp?v=1772137544"
      }
    },
    {
      id: "ck_glow",
      name: "Glow Calvin Klein",
      brand: "Calvin Klein",
      image: "https://magicperfume.co/cdn/shop/files/Glow.webp?v=1772137808",
      top_notes: ["Grüne Noten", "Zitrone", "Bergamotte"],
      heart_notes: ["Jasmin", "Maiglöckchen", "Rose"],
      base_notes: ["Moschus", "Amber", "Sandelholz"],
      description: "Ein leichter und strahlender Duft, der die innere Schönheit betont.",
      year: "2002",
      gender: "Female",
      productNumbers: ["007"],
      shopifyProduct: {
        title: "Riecht wie... Glow - No. 007 (w)",
        url: "https://magicperfume.co/products/magic-perfume-no-007w",
        price: "€11.99",
        image: "https://magicperfume.co/cdn/shop/files/Glow.webp?v=1772137808"
      }
    },
    {
      id: "ck_women",
      name: "CK Women Calvin Klein",
      brand: "Calvin Klein",
      image: "https://magicperfume.co/cdn/shop/files/ck_women.webp?v=1772137384",
      top_notes: ["Bergamotte", "Mandarine", "Grüne Noten"],
      heart_notes: ["Jasmin", "Rose", "Maiglöckchen"],
      base_notes: ["Moschus", "Amber", "Sandelholz"],
      description: "Ein frischer und femininer Duft für die moderne Frau.",
      year: "2002",
      gender: "Female",
      productNumbers: ["031"],
      shopifyProduct: {
        title: "Riecht wie... CK Women - No. 031 (w)",
        url: "https://magicperfume.co/products/magic-perfume-no-031w",
        price: "€11.99",
        image: "https://magicperfume.co/cdn/shop/files/ck_women.webp?v=1772137384"
      }
    },
    {
      id: "ck_be",
      name: "CK Be Calvin Klein",
      brand: "Calvin Klein",
      image: "https://magicperfume.co/cdn/shop/files/CK_be.webp?v=1772142766",
      top_notes: ["Bergamotte", "Lavendel", "Wacholder"],
      heart_notes: ["Jasmin", "Grüne Noten", "Pfirsich"],
      base_notes: ["Moschus", "Sandelholz", "Zeder"],
      description: "Ein frischer und maskuliner Duft für den modernen Mann.",
      year: "1996",
      gender: "Male",
      productNumbers: ["477"],
      shopifyProduct: {
        title: "Riecht wie... CK Be - No. 477 (m)",
        url: "https://magicperfume.co/products/magic-perfume-no-477m",
        price: "€11.99",
        image: "https://magicperfume.co/cdn/shop/files/CK_be.webp?v=1772142766"
      }
    },
    {
      id: "ck_euphoria_men",
      name: "Euphoria Men Calvin Klein",
      brand: "Calvin Klein",
      image: "https://magicperfume.co/cdn/shop/files/Euphoria_Men.webp?v=1772140949",
      top_notes: ["Gurke", "Melone", "Basilikum"],
      heart_notes: ["Salbei", "Zeder", "Moschus"],
      base_notes: ["Amber", "Sandelholz", "Patschuli"],
      description: "Ein frischer und maskuliner Duft für den selbstbewussten Mann.",
      year: "2006",
      gender: "Male",
      productNumbers: ["204"],
      shopifyProduct: {
        title: "Riecht wie... Euphoria Men - No. 204 (m)",
        url: "https://magicperfume.co/products/magic-perfume-no-204m",
        price: "€11.99",
        image: "https://magicperfume.co/cdn/shop/files/Euphoria_Men.webp?v=1772140949"
      }
    }
  ],

  // ===== NARCISO RODRIGUEZ =====
  narciso: [
    {
      id: "narciso_musc_noir",
      name: "Musc Noir Narciso Rodriguez",
      brand: "Narciso Rodriguez",
      image: "https://magicperfume.co/cdn/shop/files/Narciso_Rodriguez_Musc_Noir_For_Her.png?v=1770292273",
      top_notes: ["Pflaume", "Bergamotte", "Mandarine"],
      heart_notes: ["Tuberose", "Jasmin", "Moschus"],
      base_notes: ["Patschuli", "Vanille", "Zeder"],
      description: "Ein sinnlicher und geheimnisvoller Duft, der die Kraft von Moschus feiert.",
      year: "2018",
      gender: "Female",
      productNumbers: ["457"],
      shopifyProduct: {
        title: "Riecht wie... Musc Noir For Her - No. 457 (w)",
        url: "https://magicperfume.co/products/magic-perfume-no-457w",
        price: "€11.99",
        image: "https://magicperfume.co/cdn/shop/files/Narciso_Rodriguez_Musc_Noir_For_Her.png?v=1770292273"
      }
    }
  ],

  // ===== DOLCE & GABBANA =====
  dolce: [
    {
      id: "dolce_light_blue",
      name: "Light Blue Dolce & Gabbana",
      brand: "Dolce & Gabbana",
      image: "https://magicperfume.co/cdn/shop/files/Dolce_Gabbana_Light_Blue.jpg?v=1770290817",
      top_notes: ["Sizilianische Zitrone", "Apfel", "Zeder"],
      heart_notes: ["Jasmin", "Weiße Rose", "Bambus"],
      base_notes: ["Zeder", "Amber", "Moschus"],
      description: "Ein frischer und sonniger Duft, der die Essenz des Mittelmeers einfängt.",
      year: "2001",
      gender: "Female",
      productNumbers: ["017"],
      shopifyProduct: {
        title: "Riecht wie... Light Blue - No. 017 (w)",
        url: "https://magicperfume.co/products/magic-perfume-no-017w",
        price: "€11.99",
        image: "https://magicperfume.co/cdn/shop/files/Dolce_Gabbana_Light_Blue.jpg?v=1770290817"
      }
    },
    {
      id: "dolce_the_one",
      name: "The One Dolce & Gabbana",
      brand: "Dolce & Gabbana",
      image: "https://magicperfume.co/cdn/shop/files/The_One.jpg?v=1770963987",
      top_notes: ["Pfirsich", "Litschi", "Mandarine"],
      heart_notes: ["Rose", "Jasmin", "Lilie"],
      base_notes: ["Vanille", "Amber", "Moschus"],
      description: "Ein anspruchsvoller und sinnlicher Duft, der die Essenz einer zeitlosen Frau einfängt.",
      year: "2006",
      gender: "Female",
      productNumbers: ["094"],
      shopifyProduct: {
        title: "Riecht wie... The One - No. 094 (w)",
        url: "https://magicperfume.co/products/magic-perfume-no-094w",
        price: "€11.99",
        image: "https://magicperfume.co/cdn/shop/files/The_One.jpg?v=1770963987"
      }
    },
    {
      id: "dolce_dolci",
      name: "Dolci Dolce & Gabbana",
      brand: "Dolce & Gabbana",
      image: "https://magicperfume.co/cdn/shop/files/Dolce.webp?v=1772139227",
      top_notes: ["Neroli", "Bergamotte", "Mandarine"],
      heart_notes: ["Jasmin", "Rose", "Orangenblüte"],
      base_notes: ["Vanille", "Moschus", "Zeder"],
      description: "Ein süßer und blumiger Duft für die romantische Frau.",
      year: "2015",
      gender: "Female",
      productNumbers: ["435"],
      shopifyProduct: {
        title: "Riecht wie... Dolci - No. 435 (w)",
        url: "https://magicperfume.co/products/magic-perfume-no-435w",
        price: "€11.99",
        image: "https://magicperfume.co/cdn/shop/files/Dolce.webp?v=1772139227"
      }
    },
    {
      id: "dolce_limperatrice_3",
      name: "L'Imperatrice 3 Dolce & Gabbana",
      brand: "Dolce & Gabbana",
      image: "https://magicperfume.co/cdn/shop/files/Dolce_7_Gabana.jpg?v=1772095859",
      top_notes: ["Wassermelone", "Kiwi", "Rhabarber"],
      heart_notes: ["Zyklamen", "Jasmin", "Moschus"],
      base_notes: ["Rosa Pfeffer", "Sandelholz", "Zeder"],
      description: "Ein frischer und fruchtiger Duft für die junge, lebendige Frau.",
      year: "2009",
      gender: "Female",
      productNumbers: ["018"],
      shopifyProduct: {
        title: "Riecht wie... L'Imperatrice 3 - No. 018 (w)",
        url: "https://magicperfume.co/products/magic-perfume-no-018w",
        price: "€15.99",
        image: "https://magicperfume.co/cdn/shop/files/Dolce_7_Gabana.jpg?v=1772095859"
      }
    }
  ],

  // ===== KENZO =====
  kenzo: [
    {
      id: "kenzo_flower",
      name: "Flower by Kenzo",
      brand: "Kenzo",
      image: "https://magicperfume.co/cdn/shop/files/KENZO_FLOWER.jpg?v=1770925860",
      top_notes: ["Weißdorn", "Schwarze Johannisbeere", "Mandarine"],
      heart_notes: ["Rose", "Jasmin", "Veilchen"],
      base_notes: ["Vanille", "Moschus", "Zeder"],
      description: "Ein poetischer und zarter Duft, der die Schönheit der Mohnblume feiert.",
      year: "2000",
      gender: "Female",
      productNumbers: ["074"],
      shopifyProduct: {
        title: "Riecht wie... Flower - No. 074 (w)",
        url: "https://magicperfume.co/products/magic-perfume-no-074w",
        price: "€11.99",
        image: "https://magicperfume.co/cdn/shop/files/KENZO_FLOWER.jpg?v=1770925860"
      }
    }
  ],

  // ===== CHLOE =====
  chloe: [
    {
      id: "chloe_chloe",
      name: "Chloé",
      brand: "Chloé",
      image: "https://magicperfume.co/cdn/shop/files/Chloe.png?v=1770221143",
      top_notes: ["Pfingstrose", "Litschi", "Freesie"],
      heart_notes: ["Magnolie", "Rose", "Maiglöckchen"],
      base_notes: ["Zeder", "Amber", "Moschus"],
      description: "Ein frischer und eleganter Rosenduft, der den Geist der modernen Frau einfängt.",
      year: "2008",
      gender: "Female",
      productNumbers: ["024"],
      shopifyProduct: {
        title: "Riecht wie... ÄQUIVALENT - No. 024 (w)",
        url: "https://magicperfume.co/products/magic-perfume-no-024w",
        price: "€11.99",
        image: "https://magicperfume.co/cdn/shop/files/Chloe.png?v=1770221143"
      }
    },
    {
      id: "chloe_nomade",
      name: "Nomade Chloé",
      brand: "Chloé",
      image: "https://magicperfume.co/cdn/shop/files/Chloe_Nomade.jpg",
      top_notes: ["Mirabelle", "Zitrone", "Bergamotte"],
      heart_notes: ["Freesie", "Jasmin", "Rose"],
      base_notes: ["Eichenmoos", "Sandelholz", "Amber"],
      description: "Ein freier und abenteuerlicher Duft für die moderne Nomadin.",
      year: "2018",
      gender: "Female",
      productNumbers: ["049"],
      shopifyProduct: {
        title: "Riecht wie… Nomade - No. 049 (w)",
        url: "https://magicperfume.co/products/magic-perfume-no-049w",
        price: "€11.99",
        image: "https://magicperfume.co/cdn/shop/files/Chloe_Nomade.jpg"
      }
    }
  ],

  // ===== HERMÈS =====
  hermes: [
    {
      id: "hermes_terre",
      name: "Terre d'Hermès",
      brand: "Hermès",
      image: "https://magicperfume.co/cdn/shop/files/Hermes_Terre_D_Hermes.png?v=1770292407",
      top_notes: ["Orange", "Grapefruit", "Feuerstein"],
      heart_notes: ["Pfeffer", "Geranie", "Zeder"],
      base_notes: ["Vetiver", "Benzoin", "Zeder", "Eichenmoos"],
      description: "Ein kraftvoller und origineller Duft, der die Verbindung zwischen Mensch und Erde feiert.",
      year: "2006",
      gender: "Male",
      productNumbers: ["227"],
      shopifyProduct: {
        title: "Riecht wie... Terre - No. 227 (m)",
        url: "https://magicperfume.co/products/magic-perfume-no-227m",
        price: "€11.99",
        image: "https://magicperfume.co/cdn/shop/files/Hermes_Terre_D_Hermes.png?v=1770292407"
      }
    }
  ],

  // ===== GUCCI =====
  gucci: [
    {
      id: "gucci_rush",
      name: "Rush Gucci",
      brand: "Gucci",
      image: "https://magicperfume.co/cdn/shop/files/gucci_rush_8034ec32-d523-4890-b475-fc7c34e77c9e.webp?v=1771658050",
      top_notes: ["Freesie", "Seerose", "Koriander"],
      heart_notes: ["Rose", "Jasmin", "Maiglöckchen"],
      base_notes: ["Sandelholz", "Moschus", "Amber"],
      description: "Ein kühner und moderner Blumenduft, der die Energie des urbanen Lebens einfängt.",
      year: "1999",
      gender: "Female",
      productNumbers: ["163"],
      shopifyProduct: {
        title: "Riecht wie... Rush 2 - No. 163 (w)",
        url: "https://magicperfume.co/products/magic-perfume-no-163w",
        price: "€11.99",
        image: "https://magicperfume.co/cdn/shop/files/gucci_rush_8034ec32-d523-4890-b475-fc7c34e77c9e.webp?v=1771658050"
      }
    },
    {
      id: "gucci_envy_me",
      name: "Envy Me Gucci",
      brand: "Gucci",
      image: "https://magicperfume.co/cdn/shop/files/Gucci_Envy_Me.webp?v=1772135696",
      top_notes: ["Pfingstrose", "Ananas", "Mandarine"],
      heart_notes: ["Jasmin", "Rose", "Litschi"],
      base_notes: ["Sandelholz", "Moschus", "Amber"],
      description: "Ein lebendiger und fruchtiger Duft für die selbstbewusste Frau.",
      year: "2004",
      gender: "Female",
      productNumbers: ["071"],
      shopifyProduct: {
        title: "Riecht wie... Envy Me - No. 071 (w)",
        url: "https://magicperfume.co/products/magic-perfume-no-071w",
        price: "€11.99",
        image: "https://magicperfume.co/cdn/shop/files/Gucci_Envy_Me.webp?v=1772135696"
      }
    }
  ],

  // ===== SALVATORE FERRAGAMO =====
  ferragamo: [
    {
      id: "ferragamo_deep_red",
      name: "Deep Red Salvatore Ferragamo",
      brand: "Salvatore Ferragamo",
      image: "https://magicperfume.co/cdn/shop/files/Hugo_Boss_Deep_Red.jpg?v=1770922424",
      top_notes: ["Schwarze Johannisbeere", "Mandarine", "Rosa Pfeffer"],
      heart_notes: ["Rose", "Jasmin", "Orangenblüte"],
      base_notes: ["Patschuli", "Vanille", "Zeder"],
      description: "Ein lebendiger und leidenschaftlicher Duft, der die Intensität von Rot einfängt.",
      year: "2006",
      gender: "Female",
      productNumbers: ["022"],
      shopifyProduct: {
        title: "Riecht wie... Deep Red - No. 022 (w)",
        url: "https://magicperfume.co/products/magic-perfume-no-022w",
        price: "€11.99",
        image: "https://magicperfume.co/cdn/shop/files/Hugo_Boss_Deep_Red.jpg?v=1770922424"
      }
    }
  ],

  // ===== DAVIDOFF =====
  davidoff: [
    {
      id: "davidoff_cool_water",
      name: "Cool Water Davidoff",
      brand: "Davidoff",
      image: "https://magicperfume.co/cdn/shop/files/Davidoff_Cool_Water.png?v=1770292092",
      top_notes: ["Meerwasser", "Minze", "Lavendel", "Rosmarin"],
      heart_notes: ["Jasmin", "Geranie", "Sandelholz"],
      base_notes: ["Moschus", "Amber", "Zeder"],
      description: "Ein frischer und aquatischer Duft, der die Kraft und Frische des Ozeans einfängt.",
      year: "1988",
      gender: "Male",
      productNumbers: ["200"],
      shopifyProduct: {
        title: "Riecht wie... Cool Water - No. 200 (m)",
        url: "https://magicperfume.co/products/magic-perfume-no-200m",
        price: "€11.99",
        image: "https://magicperfume.co/cdn/shop/files/Davidoff_Cool_Water.png?v=1770292092"
      }
    }
  ],

  // ===== DIESEL =====
  diesel: [
    {
      id: "diesel_only_the_brave",
      name: "Only The Brave Diesel",
      brand: "Diesel",
      image: "https://magicperfume.co/cdn/shop/files/Only_The_Brave.webp?v=1772141539",
      top_notes: ["Zitrone", "Mandarine", "Koriander"],
      heart_notes: ["Leder", "Veilchen", "Tabak"],
      base_notes: ["Amber", "Moschus", "Zeder"],
      description: "Ein kraftvoller und maskuliner Duft für mutige Männer.",
      year: "2009",
      gender: "Male",
      productNumbers: ["239"],
      shopifyProduct: {
        title: "Riecht wie... Only The Brave - No. 239 (m)",
        url: "https://magicperfume.co/products/magic-perfume-no-239m",
        price: "€11.99",
        image: "https://magicperfume.co/cdn/shop/files/Only_The_Brave.webp?v=1772141539"
      }
    }
  ],

  // ===== CAMPBELL =====
  campbell: [
    {
      id: "campbell_campbell",
      name: "Campbell Naomi Campbell",
      brand: "Campbell",
      image: "https://magicperfume.co/cdn/shop/files/Campbell.webp?v=1772140165",
      top_notes: ["Vanille", "Karamell", "Kokosnuss"],
      heart_notes: ["Sandelholz", "Tonkabohne", "Heliotrop"],
      base_notes: ["Sternanis", "Moschus", "Benzoin"],
      description: "Ein süßer und exotischer Duft für die moderne Frau.",
      year: "2015",
      gender: "Female",
      productNumbers: ["056"],
      shopifyProduct: {
        title: "Riecht wie... Campbell - No. 056 (w)",
        url: "https://magicperfume.co/products/magic-perfume-no-056w",
        price: "€20.99",
        image: "https://magicperfume.co/cdn/shop/files/Campbell.webp?v=1772140165"
      }
    }
  ],

  // ===== JOOP! =====
  joop: [
    {
      id: "joop_homme",
      name: "Joop! Homme",
      brand: "Joop!",
      image: "https://magicperfume.co/cdn/shop/files/Joop_Homme.png?v=1770286089",
      top_notes: ["Zimt", "Bergamotte", "Mandarine"],
      heart_notes: ["Maiglöckchen", "Jasmin", "Geranie"],
      base_notes: ["Sandelholz", "Vanille", "Tonkabohne", "Zeder"],
      description: "Ein kühner und unverwechselbarer Duft, der sowohl süß als auch würzig ist.",
      year: "1989",
      gender: "Male",
      productNumbers: ["211"],
      shopifyProduct: {
        title: "Riecht wie... Joop Homme - No. 211 (m)",
        url: "https://magicperfume.co/products/magic-perfume-no-211m",
        price: "€11.99",
        image: "https://magicperfume.co/cdn/shop/files/Joop_Homme.png?v=1770286089"
      }
    }
  ],

  // ===== ADIDAS =====
  adidas: [
    {
      id: "adidas_adventure",
      name: "Adventure Adidas",
      brand: "Adidas",
      image: "https://magicperfume.co/cdn/shop/files/Adventure.webp?v=1772140535",
      top_notes: ["Bergamotte", "Zitrone", "Mandarine"],
      heart_notes: ["Jasmin", "Rose", "Maiglöckchen"],
      base_notes: ["Zeder", "Moschus", "Amber"],
      description: "Ein frischer und sportlicher Duft für den aktiven Mann.",
      year: "2008",
      gender: "Male",
      productNumbers: ["213"],
      shopifyProduct: {
        title: "Riecht wie... Adventure - No. 213 (m)",
        url: "https://magicperfume.co/products/magic-perfume-no-213m",
        price: "€11.99",
        image: "https://magicperfume.co/cdn/shop/files/Adventure.webp?v=1772140535"
      }
    }
  ],

  // ===== DOLCE VITA =====
  dolceVita: [
    {
      id: "dolce_vita_vita",
      name: "Vita Dolce Vita",
      brand: "Dolce Vita",
      image: "https://magicperfume.co/cdn/shop/files/Dolce_Vita.webp?v=1772140820",
      top_notes: ["Zimt", "Kardamom", "Bergamotte"],
      heart_notes: ["Rose", "Lilie", "Zeder"],
      base_notes: ["Vanille", "Sandelholz", "Moschus"],
      description: "Ein lebendiger und sonniger Duft, der die Freude am Leben feiert.",
      year: "2010",
      gender: "Female",
      productNumbers: ["116"],
      shopifyProduct: {
        title: "Riecht wie... Vita - No. 116 (w)",
        url: "https://magicperfume.co/products/magic-perfume-no-116w",
        price: "€20.99",
        image: "https://magicperfume.co/cdn/shop/files/Dolce_Vita.webp?v=1772140820"
      }
    }
  ],

  // ===== CARTIER =====
  cartier: [
    {
      id: "cartier_la_panthere",
      name: "La Panthère Cartier",
      brand: "Cartier",
      image: "https://magicperfume.co/cdn/shop/files/La_Panthere.webp?v=1772141818",
      top_notes: ["Erdbeere", "Rhabarber", "Getrocknete Früchte"],
      heart_notes: ["Gardenie", "Eichenmoos", "Moschus"],
      base_notes: ["Moschus", "Amber", "Sandelholz"],
      description: "Ein geheimnisvoller und sinnlicher Duft für die wilde Frau.",
      year: "2014",
      gender: "Female",
      productNumbers: ["421"],
      shopifyProduct: {
        title: "Riecht wie... La Panthere - No. 421 (w)",
        url: "https://magicperfume.co/products/magic-perfume-no-421w",
        price: "€11.99",
        image: "https://magicperfume.co/cdn/shop/files/La_Panthere.webp?v=1772141818"
      }
    }
  ],

  // ===== OTHERS =====
  others: [
    {
      id: "the_only_one_032",
      name: "The Only One",
      brand: "The Only One",
      image: "https://magicperfume.co/cdn/shop/files/The_One.jpg?v=1770963987",
      top_notes: ["Karamell", "Vanille", "Kaffee"],
      heart_notes: ["Iris", "Frucht", "Patschuli"],
      base_notes: ["Bergamotte", "Orange", "Orangenblüte", "Rose"],
      description: "Ein eleganter und verführerischer Duft.",
      year: "",
      gender: "Female",
      productNumbers: ["032"],
      shopifyProduct: {
        title: "Riecht wie... The Only One - No. 032 (w)",
        url: "https://magicperfume.co/products/magic-perfume-no-032w",
        price: "€11.99",
        image: "https://magicperfume.co/cdn/shop/files/The_One.jpg?v=1770963987"
      }
    },
    {
      id: "obsession_night_woman_028",
      name: "Obsession Night Woman",
      brand: "Obsession",
      image: "https://magicperfume.co/cdn/shop/files/Obsession_Night_Woman.webp?v=1772136464",
      top_notes: ["Mandarine", "Bergamotte", "Rote Früchte"],
      heart_notes: ["Jasmin", "Rose", "Orangenblüte"],
      base_notes: ["Vanille", "Moschus", "Amber"],
      description: "Ein geheimnisvoller und sinnlicher Duft für die Nacht.",
      year: "",
      gender: "Female",
      productNumbers: ["028"],
      shopifyProduct: {
        title: "Riecht wie... Obsession Night WOMAN - No. 028 (w)",
        url: "https://magicperfume.co/products/magic-perfume-no-028w",
        price: "€11.99",
        image: "https://magicperfume.co/cdn/shop/files/Obsession_Night_Woman.webp?v=1772136464"
      }
    },
    {
      id: "fruity_floral_488",
      name: "Fruity Floral",
      brand: "Fruity Floral",
      image: "https://magicperfume.co/cdn/shop/files/aventus.webp?v=1772533006",
      top_notes: ["Fruchtnoten", "Zitrusfrüchte", "Bergamotte"],
      heart_notes: ["Blumige Noten", "Jasmin", "Rose"],
      base_notes: ["Moschus", "Amber", "Sandelholz"],
      description: "Ein fruchtig-blumiger Duft für die moderne Frau.",
      year: "",
      gender: "Female",
      productNumbers: ["488"],
      shopifyProduct: {
        title: "No. 488 – Fruity Floral (w)",
        url: "https://magicperfume.co/products/magic-perfume-no-488w",
        price: "€11.99",
        image: "https://magicperfume.co/cdn/shop/files/aventus.webp?v=1772533006"
      }
    },
    {
      id: "dione_008",
      name: "Dione",
      brand: "Dione",
      image: "https://magicperfume.co/cdn/shop/files/MagicPerfume-79-300x300.png?v=1769157021",
      top_notes: ["Bergamotte", "Zitrone", "Mandarine"],
      heart_notes: ["Jasmin", "Rose", "Maiglöckchen"],
      base_notes: ["Moschus", "Amber", "Zeder"],
      description: "Ein eleganter und zeitloser Duft.",
      year: "",
      gender: "Female",
      productNumbers: ["008"],
      shopifyProduct: {
        title: "Riecht wie... Dione - No. 008 (w)",
        url: "https://magicperfume.co/products/magic-perfume-no-008w",
        price: "€11.99",
        image: "https://magicperfume.co/cdn/shop/files/MagicPerfume-79-300x300.png?v=1769157021"
      }
    },
    {
      id: "q_340",
      name: "Q",
      brand: "Q",
      image: "https://magicperfume.co/cdn/shop/files/Q_EDP.webp?v=1772143999",
      top_notes: ["Bergamotte", "Zitrone", "Grapefruit"],
      heart_notes: ["Jasmin", "Rose", "Veilchen"],
      base_notes: ["Moschus", "Amber", "Zeder"],
      description: "Ein moderner und frischer Duft.",
      year: "",
      gender: "Unisex",
      productNumbers: ["340"],
      shopifyProduct: {
        title: "Riecht wie... Q - No. 340 (unisex)",
        url: "https://magicperfume.co/products/magic-perfume-no-340m",
        price: "€11.99",
        image: "https://magicperfume.co/cdn/shop/files/Q_EDP.webp?v=1772143999"
      }
    },
    {
      id: "rose_tangerine_097",
      name: "Rose Tangerine",
      brand: "Rose Tangerine",
      image: "https://magicperfume.co/cdn/shop/files/Chloe.png?v=1770221143",
      top_notes: ["Mandarine", "Orange", "Grapefruit"],
      heart_notes: ["Rose", "Jasmin", "Pfingstrose"],
      base_notes: ["Moschus", "Amber", "Zeder"],
      description: "Ein frischer und fruchtiger Rosenduft.",
      year: "",
      gender: "Female",
      productNumbers: ["097"],
      shopifyProduct: {
        title: "Riecht wie... Rose Tangerine - No. 097 (w)",
        url: "https://magicperfume.co/products/magic-perfume-no-097w",
        price: "€11.99",
        image: "https://magicperfume.co/cdn/shop/files/Chloe.png?v=1770221143"
      }
    }
  ]
};

// ===== HELPER FUNCTIONS =====
window.PerfumeCatalog.getShopifyProductByPerfumeId = function(perfumeId) {
  for (let brandKey in this) {
    if (Array.isArray(this[brandKey])) {
      const perfume = this[brandKey].find(p => p.id === perfumeId);
      if (perfume && perfume.shopifyProduct) {
        return perfume.shopifyProduct;
      }
    }
  }
  return null;
};

window.PerfumeCatalog.getShopifyProductByPerfumeName = function(perfumeName) {
  const searchName = perfumeName.toLowerCase().trim();
  
  for (let brandKey in this) {
    if (Array.isArray(this[brandKey])) {
      const perfume = this[brandKey].find(p => 
        p.name.toLowerCase().includes(searchName) || 
        searchName.includes(p.name.toLowerCase())
      );
      if (perfume && perfume.shopifyProduct) {
        return perfume.shopifyProduct;
      }
    }
  }
  return null;
};

window.PerfumeCatalog.getShopifyProductByNumber = function(number) {
  const numStr = number.toString().padStart(3, '0');
  
  for (let brandKey in this) {
    if (Array.isArray(this[brandKey])) {
      const perfume = this[brandKey].find(p => 
        p.productNumbers && p.productNumbers.includes(numStr)
      );
      if (perfume && perfume.shopifyProduct) {
        return perfume.shopifyProduct;
      }
    }
  }
  return null;
};

window.PerfumeCatalog.search = function(query) {
  if (!query || query.length < 2) return [];
  
  const results = [];
  const queryLower = query.toLowerCase().trim();
  
  for (let brandKey in this) {
    if (Array.isArray(this[brandKey])) {
      this[brandKey].forEach(perfume => {
        const searchableText = [
          perfume.name,
          perfume.brand,
          perfume.year,
          ...(perfume.top_notes || []),
          ...(perfume.heart_notes || []),
          ...(perfume.base_notes || []),
          ...(perfume.productNumbers || [])
        ].join(' ').toLowerCase();
        
        if (searchableText.includes(queryLower)) {
          results.push(perfume);
        }
      });
    }
  }
  
  return results.sort((a, b) => a.name.localeCompare(b.name));
};

window.PerfumeCatalog.findById = function(id) {
  for (let brandKey in this) {
    if (Array.isArray(this[brandKey])) {
      const found = this[brandKey].find(p => p.id === id);
      if (found) return found;
    }
  }
  return null;
};

window.PerfumeCatalog.getBrands = function() {
  const brands = [];
  for (let brandKey in this) {
    if (Array.isArray(this[brandKey])) {
      brands.push(brandKey);
    }
  }
  return brands;
};

window.PerfumeCatalog.getProductsByBrand = function(brandKey) {
  if (this[brandKey] && Array.isArray(this[brandKey])) {
    return this[brandKey];
  }
  return [];
};

window.PerfumeCatalog.getProductNumbers = function() {
  const numbers = [];
  for (let brandKey in this) {
    if (Array.isArray(this[brandKey])) {
      this[brandKey].forEach(perfume => {
        if (perfume.productNumbers) {
          numbers.push(...perfume.productNumbers);
        }
      });
    }
  }
  return [...new Set(numbers)].sort();
};

console.log('✓ German PerfumeCatalog loaded with', 
  Object.keys(window.PerfumeCatalog).filter(key => Array.isArray(window.PerfumeCatalog[key])).length, 
  'brand categories and', 
  window.PerfumeCatalog.getProductNumbers().length, 
  'product numbers');